"use client";
import { C as e, S as t, _ as n, a as r, b as i, c as a, d as o, f as s, g as c, h as l, i as u, l as d, m as f, n as p, o as m, p as h, r as g, s as _, t as v, u as y, v as b, w as x, x as S, y as C } from "./seed-Bzz9ideE.js";
import { a as w, i as T, n as E, r as D } from "./registration-BkPgmtZ2.js";
import { Suspense as O, createContext as k, memo as A, useCallback as j, useContext as M, useEffect as N, useId as P, useLayoutEffect as F, useMemo as I, useRef as L, useState as R, useSyncExternalStore as z } from "react";
import { Fragment as B, jsx as V, jsxs as H } from "react/jsx-runtime";
import { animate as ee, motion as U, useMotionValue as te, useTransform as ne } from "motion/react";
import { uniformInt as W } from "pure-rand/distribution/uniformInt";
import { QueryClient as re, useMutation as G, useQuery as ie } from "@tanstack/react-query";
//#region src/react/LootConfigContext.ts
var K = k({});
function ae() {
	return M(K);
}
//#endregion
//#region src/sounds/SoundPlayer.ts
var oe = class {
	context = null;
	gainNode = null;
	buffers = /* @__PURE__ */ new Map();
	volumeValue = 1;
	get volume() {
		return this.volumeValue;
	}
	setVolume(e) {
		this.volumeValue = Math.max(0, Math.min(1, e)), this.gainNode && (this.gainNode.gain.value = this.volumeValue);
	}
	ensureContext() {
		if (this.context) return this.context;
		if (typeof window > "u") return null;
		let e = window.AudioContext ?? window.webkitAudioContext;
		if (!e) return null;
		try {
			this.context = new e(), this.gainNode = this.context.createGain(), this.gainNode.gain.value = this.volumeValue, this.gainNode.connect(this.context.destination);
		} catch {
			this.context = null, this.gainNode = null;
		}
		return this.context;
	}
	unlock() {
		let e = this.ensureContext();
		e && e.state === "suspended" && e.resume().catch(() => {});
	}
	preload(e) {
		this.getBuffer(e);
	}
	getBuffer(e) {
		let t = this.buffers.get(e);
		if (t) return t;
		let n = this.ensureContext(), r = n ? fetch(e).then((e) => e.ok ? e.arrayBuffer() : null).then((e) => e ? n.decodeAudioData(e) : null).catch(() => null) : Promise.resolve(null);
		return this.buffers.set(e, r), r;
	}
	play(e, t) {
		if (!e) return;
		let n = this.ensureContext();
		!n || !this.gainNode || this.getBuffer(e).then((e) => {
			if (!(!e || !this.gainNode)) try {
				let r = n.createBufferSource();
				if (r.buffer = e, t?.volume !== void 0) {
					let e = n.createGain();
					e.gain.value = Math.max(0, Math.min(1, t.volume)), r.connect(e), e.connect(this.gainNode);
				} else r.connect(this.gainNode);
				r.start();
			} catch {}
		});
	}
	dispose() {
		this.buffers.clear(), this.context?.close().catch(() => {}), this.context = null, this.gainNode = null;
	}
}, se = {
	tick: "tick.mp3",
	badPrize: "bad-prize.mp3",
	rarePrize: "rare-prize.mp3",
	megaPrize: "mega-prize.mp3"
};
function ce(e, t) {
	if (e === !1) return null;
	let n = t?.replace(/\/$/, ""), r = {
		...n ? {
			tick: `${n}/${se.tick}`,
			badPrize: `${n}/${se.badPrize}`,
			rarePrize: `${n}/${se.rarePrize}`,
			megaPrize: `${n}/${se.megaPrize}`
		} : {},
		...e
	};
	return Object.values(r).some(Boolean) ? r : null;
}
function le({ sounds: e, soundBaseUrl: t }) {
	let n = L(null), r = I(() => ce(e, t), [e, t]), i = L(r);
	i.current = r;
	let a = L(e === !1);
	return a.current = e === !1, N(() => () => {
		n.current?.dispose(), n.current = null;
	}, []), I(() => {
		let e = () => (n.current ||= new oe(), n.current);
		return {
			get enabled() {
				return !a.current;
			},
			playTickSound: () => {
				let t = i.current;
				t?.tick && e().play(t.tick);
			},
			playRaritySound: (t) => {
				let n = i.current;
				n && (t === 2 || t === 3 ? e().play(n.rarePrize) : t >= 4 ? e().play(n.megaPrize) : e().play(n.badPrize));
			},
			unlock: () => {
				if (!i.current) return;
				let t = e();
				t.unlock();
				for (let e of Object.values(i.current)) e && t.preload(e);
			}
		};
	}, []);
}
//#endregion
//#region src/utils/cx.ts
function q(...e) {
	return e.filter(Boolean).join(" ");
}
//#endregion
//#region src/battle/BattlesIcon.tsx
function J({ size: e = 16, className: t }) {
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: t,
		width: e,
		height: e,
		viewBox: "0 0 40 40",
		fill: "currentColor",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ V("path", { d: "M25.156 2.703c-.083.11-.902 1.18-1.829 2.382-.923 1.197-1.972 2.564-2.334 3.03-.356.466-.757.98-.883 1.14l-.235.297-3.361.008-3.361.013.849.431c.465.236 1.245.632 1.728.88l.875.457-.235.553c-.13.305-.266.61-.296.684-.035.07-.222.513-.418.979s-.588 1.389-.87 2.046c-.284.658-.615 1.441-.74 1.742-.127.3-.275.64-.327.762a45 45 0 0 0-.275.63c-.418.99-1.058 2.504-1.532 3.614-.279.658-.523 1.237-.54 1.28-.013.044-.04.07-.052.061-.013-.013 0-1.119.022-2.455.143-7.532.165-9.495.113-9.548a8 8 0 0 0-.675-.322c-.348-.157-1.102-.492-1.676-.749-2.094-.936-2.386-1.066-2.408-1.066-.026 0 .035 12.782.074 15.412l.026 1.806h7.662l.144-.283c.079-.156.388-.831.693-1.502.635-1.415 1.558-3.46 1.785-3.962.087-.191.23-.509.326-.71.092-.2.166-.37.166-.378s.056-.14.126-.292.187-.413.265-.579c.079-.17.214-.47.305-.674.274-.619 1.602-3.57 1.842-4.093.126-.274.614-1.367.857-1.915.179-.405.388-.867.871-1.938.174-.383.4-.884.5-1.11s.414-.923.697-1.546l.793-1.763c.157-.348.33-.74.392-.87.06-.131.274-.614.479-1.067.204-.457.448-.993.54-1.193.19-.414.186-.396.117-.392-.03 0-.122.092-.2.2M24.32 13.187c-.832.091-1.472.257-1.981.51-.41.208-.958.787-1.206 1.275-.257.505-.296.631-.557 1.828-.122.549-.266 1.206-.327 1.459-.257 1.106-.305 1.754-.161 2.268.213.762.71 1.11 3.644 2.564 2.277 1.124 2.808 1.463 2.808 1.79 0 .178-.344 1.693-.418 1.833-.135.26-.213.274-1.628.274-1.389 0-1.454-.009-1.506-.226-.022-.075.047-.475.191-1.12.122-.548.213-1.01.2-1.023-.008-.012-1.132.2-2.49.475-1.358.27-2.512.505-2.56.514-.1.017-.157.13-.714 1.38-.052.117-.257.579-.457 1.023s-.492 1.097-.653 1.459c-.161.357-.34.761-.4.892-.061.13-.236.514-.384.849-.152.335-.413.923-.587 1.306-.31.692-1.324 2.956-1.49 3.33-.047.11-.165.358-.256.558-.096.2-.17.37-.17.383 0 .009-.07.165-.157.348-.16.331-.17.453-.021.296.047-.043.444-.553.883-1.127a1251 1251 0 0 1 2.295-2.983c.823-1.066 1.75-2.277 2.068-2.686.409-.544.587-.744.635-.723.214.088.823.244 1.198.31.383.065.831.074 3.722.074 2.93 0 3.335-.01 3.744-.079.744-.122 1.171-.244 1.602-.448.67-.322 1.145-.866 1.476-1.694.135-.348.196-.583.557-2.242.083-.37.187-.853.24-1.066.048-.218.1-.619.117-.893.04-.77-.109-1.219-.535-1.61-.462-.427-.989-.715-4.154-2.256-.97-.474-1.462-.77-1.763-1.075-.235-.235-.24-.275-.082-1.002.26-1.236.317-1.375.622-1.458.087-.022.684-.044 1.323-.044 1.29 0 1.437.022 1.494.244.026.105-.083.68-.335 1.755-.048.2-.079.374-.066.387.022.022.24-.022 2.268-.457 1.746-.374 2.473-.536 2.49-.549.014-.017.249-1.031.41-1.793.109-.527.109-1.145-.004-1.507a1.68 1.68 0 0 0-.601-.835c-.361-.244-1.05-.427-1.903-.51-.696-.065-5.781-.048-6.421.022" })
	});
}
var Y = {
	root: "_root_1pxwx_5",
	grid: "_grid_1pxwx_20",
	column: "_column_1pxwx_32",
	columnLastInRow: "_columnLastInRow_1pxwx_42",
	columnLastRow: "_columnLastRow_1pxwx_46",
	columnGrid: "_columnGrid_1pxwx_50",
	columnInner: "_columnInner_1pxwx_54",
	columnInnerCompact: "_columnInnerCompact_1pxwx_70",
	columnInnerGrid: "_columnInnerGrid_1pxwx_74",
	columnInnerBare: "_columnInnerBare_1pxwx_78",
	header: "_header_1pxwx_85",
	headerRight: "_headerRight_1pxwx_97",
	headerCompact: "_headerCompact_1pxwx_108",
	viewport: "_viewport_1pxwx_117",
	viewportVertical: "_viewportVertical_1pxwx_127",
	viewportHorizontal: "_viewportHorizontal_1pxwx_131",
	viewportAbsoluteTop: "_viewportAbsoluteTop_1pxwx_135",
	viewportAbsoluteCenter: "_viewportAbsoluteCenter_1pxwx_140",
	fade: "_fade_1pxwx_147",
	fadeLeft: "_fadeLeft_1pxwx_152",
	fadeRight: "_fadeRight_1pxwx_163",
	fadeTop: "_fadeTop_1pxwx_174",
	fadeBottom: "_fadeBottom_1pxwx_188",
	frame: "_frame_1pxwx_204",
	rail: "_rail_1pxwx_212",
	railStartHorizontal: "_railStartHorizontal_1pxwx_216",
	railStartHorizontalFlipped: "_railStartHorizontalFlipped_1pxwx_222",
	railEndHorizontal: "_railEndHorizontal_1pxwx_228",
	railEndHorizontalFlipped: "_railEndHorizontalFlipped_1pxwx_234",
	railStartVertical: "_railStartVertical_1pxwx_240",
	railEndVertical: "_railEndVertical_1pxwx_246",
	reelViewport: "_reelViewport_1pxwx_254",
	reelClip: "_reelClip_1pxwx_261",
	reelClipHorizontal: "_reelClipHorizontal_1pxwx_266",
	reel: "_reel_1pxwx_254",
	reelVertical: "_reelVertical_1pxwx_281",
	slotAnchor: "_slotAnchor_1pxwx_285",
	slot: "_slot_1pxwx_285",
	slotCard: "_slotCard_1pxwx_299",
	slotImageFrame: "_slotImageFrame_1pxwx_309",
	slotImage: "_slotImage_1pxwx_309",
	slotImageRevealed: "_slotImageRevealed_1pxwx_327",
	slotImageMissing: "_slotImageMissing_1pxwx_332",
	slotValue: "_slotValue_1pxwx_340",
	slotValueCompact: "_slotValueCompact_1pxwx_352",
	slotValueCompactTarget: "_slotValueCompactTarget_1pxwx_357",
	glow: "_glow_1pxwx_362",
	glowSmall: "_glowSmall_1pxwx_371",
	glowVertical: "_glowVertical_1pxwx_375",
	emptyReel: "_emptyReel_1pxwx_381",
	emptyReelVertical: "_emptyReelVertical_1pxwx_391",
	emptyCard: "_emptyCard_1pxwx_395",
	emptyIcon: "_emptyIcon_1pxwx_406",
	vsChip: "_vsChip_1pxwx_412",
	vsChipBox: "_vsChipBox_1pxwx_419",
	starting: "_starting_1pxwx_433",
	startingLabel: "_startingLabel_1pxwx_450",
	startingLuck: "_startingLuck_1pxwx_458",
	startingCount: "_startingCount_1pxwx_462",
	startingDigit: "_startingDigit_1pxwx_471",
	startingGo: "_startingGo_1pxwx_481",
	startingSeats: "_startingSeats_1pxwx_486",
	results: "_results_1pxwx_494",
	resultsSeat: "_resultsSeat_1pxwx_500",
	resultsHeader: "_resultsHeader_1pxwx_506",
	resultsTotal: "_resultsTotal_1pxwx_517",
	resultsCards: "_resultsCards_1pxwx_533",
	resultCard: "_resultCard_1pxwx_543",
	resultCardImage: "_resultCardImage_1pxwx_557",
	resultCardImageMissing: "_resultCardImageMissing_1pxwx_565",
	resultCardName: "_resultCardName_1pxwx_571",
	resultCardValue: "_resultCardValue_1pxwx_584",
	resultPlaceholder: "_resultPlaceholder_1pxwx_591",
	resultPlaceholderLabel: "_resultPlaceholderLabel_1pxwx_600",
	resultPlaceholderNumber: "_resultPlaceholderNumber_1pxwx_606",
	resultsMobile: "_resultsMobile_1pxwx_612",
	resultsMobileSeat: "_resultsMobileSeat_1pxwx_619",
	resultsMobileHeader: "_resultsMobileHeader_1pxwx_626",
	resultsMobileTotal: "_resultsMobileTotal_1pxwx_634",
	resultsMobileStrip: "_resultsMobileStrip_1pxwx_641"
};
//#endregion
//#region src/battle/BattleOpenerDividers.tsx
function ue({ layout: e }) {
	return e.playerCount <= 1 || e.dividerMode === "none" ? null : e.dividerMode === "center" ? /* @__PURE__ */ V(de, {
		leftPct: 50,
		topPct: 50
	}) : e.dividerMode === "two-column-rows" ? /* @__PURE__ */ V(B, { children: Array.from({ length: e.rows }, (t, n) => /* @__PURE__ */ V(de, {
		leftPct: 50,
		topPct: (n + .5) / e.rows * 100
	}, n)) }) : /* @__PURE__ */ V(B, { children: Array.from({ length: e.columns - 1 }, (t, n) => /* @__PURE__ */ V(de, {
		leftPct: (n + 1) / e.columns * 100,
		topPct: 50
	}, n)) });
}
function de({ leftPct: e, topPct: t }) {
	return /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: Y.vsChip,
		style: {
			left: `${e}%`,
			top: `${t}%`
		},
		children: /* @__PURE__ */ V("div", {
			className: Y.vsChipBox,
			children: /* @__PURE__ */ V(J, { size: 16 })
		})
	});
}
//#endregion
//#region src/battle/battleSpinnerGeometry.ts
var fe = .68, pe = .25, me = 1, he = 1, ge = 107 / 128, _e = 96 / 128, ve = .5, ye = .3, be = 68, xe = 108, Se = 81, Ce = 52, we = 44, Te = 70, Ee = 51, De = 37, Oe = 6, ke = 22, Ae = 79, je = 126, Me = 42, Ne = 54, Pe = 162, Fe = 64, Ie = -95, Le = 1, Re = 8, ze = 6, Be = 32, Ve = 16, He = 111, Ue = 100, We = 83, Ge = 81, Ke = 51, qe = 24, Je = 65 / 80, Ye = 60 / 71, Xe = .25, Ze = 8, Qe = 6;
function $e(e, t) {
	let n = [], r = 0;
	for (let i of e) n.push(r), r += i + t;
	return n;
}
function et({ index: e, endingItemIdx: t, isHorizontal: n, itemHeight: r, itemWidth: i }) {
	return n ? i <= 60 ? e === t ? Ge : Ke : e === t ? i : i <= 100 ? We : Math.abs(e - t) === 1 ? He : Ue : e === t ? Pe : e === t - 1 ? Ne : e === t + 1 ? Fe : r;
}
function tt({ isHorizontal: e, itemWidth: t }) {
	return e ? t <= 60 ? qe : t <= 100 ? Ve : Be : Me;
}
function nt({ index: e, endingItemIdx: t, isHorizontal: n, itemWidth: r }) {
	return n ? e === t && r <= 60 ? -3 : e === t && r >= 120 ? 6 : 0 : e === t ? -28 : e === t - 1 ? Ie : e === t + 1 ? Le : 0;
}
function rt({ offset: e, index: t, endingItemIdx: n, isHorizontal: r, itemHeight: i, itemWidth: a, slotMainSize: o }) {
	return r ? e + o / 2 : e + nt({
		index: t,
		endingItemIdx: n,
		isHorizontal: r,
		itemWidth: a
	}) + i / 2;
}
function it(e) {
	return 68 + e / 2;
}
function at(e) {
	return fe + .31999999999999995 * e;
}
function ot(e) {
	return pe + .75 * e;
}
function st({ distance: e, itemWidth: t }) {
	let n = lt(t);
	return ut({
		distance: e,
		nearDistance: n.nearDistance,
		farDistance: n.farDistance,
		centerValue: me,
		nearValue: n.nearScale,
		farValue: n.farScale,
		baseValue: fe
	});
}
function ct({ distance: e, itemWidth: t }) {
	let n = lt(t);
	return ut({
		distance: e,
		nearDistance: n.nearDistance,
		farDistance: n.farDistance,
		centerValue: he,
		nearValue: n.nearOpacity,
		farValue: n.farOpacity,
		baseValue: pe
	});
}
function lt(e) {
	let t = e <= 100, n = e <= 60, r = tt({
		isHorizontal: !0,
		itemWidth: e
	}), i = n ? Ke : t ? We : He, a = n ? Ke : t ? We : Ue, o = n ? Je : e === 71 ? Ye : ge, s = n ? Je : e === 71 ? Ye : t ? ge : _e, c = n ? Xe : ve, l = n ? Xe : t ? ve : ye, u = e / 2 + r + i / 2;
	return {
		nearDistance: u,
		farDistance: u + i / 2 + r + a / 2,
		nearScale: o,
		farScale: s,
		nearOpacity: c,
		farOpacity: l
	};
}
function ut({ distance: e, nearDistance: t, farDistance: n, centerValue: r, nearValue: i, farValue: a, baseValue: o }) {
	return dt(e <= t ? {
		progress: e / t,
		from: r,
		to: i
	} : e <= n ? {
		progress: (e - t) / (n - t),
		from: i,
		to: a
	} : {
		progress: Math.min(1, (e - n) / t),
		from: a,
		to: o
	});
}
function dt({ progress: e, from: t, to: n }) {
	return t + (n - t) * e;
}
function ft({ isHorizontal: e, itemWidth: t }) {
	return e ? t <= 60 ? {
		width: Ee,
		height: De
	} : t === 71 ? {
		width: we,
		height: Te
	} : t <= 100 ? {
		width: Se,
		height: Ce
	} : {
		width: be,
		height: xe
	} : {
		width: Ae,
		height: je
	};
}
function pt(e) {
	return e === 71 ? Oe : e <= 60 ? ke : 40;
}
function mt({ index: e, endingItemIdx: t, isHorizontal: n, itemWidth: r }) {
	return n ? r === 71 ? e === t ? Ze : Qe : e === t && r <= 60 ? 9 : 4 : e === t ? Re : ze;
}
//#endregion
//#region src/battle/BattleEmptyReel.tsx
var ht = [
	.12,
	.2,
	.36,
	.58,
	.36,
	.2,
	.12
];
function gt({ orientation: e, item: t }) {
	return /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: q(Y.emptyReel, e === "vertical" && Y.emptyReelVertical),
		style: { gap: 12 },
		"data-los-battle-empty-reel": !0,
		children: ht.map((e, n) => /* @__PURE__ */ V("div", {
			className: Y.emptyCard,
			style: {
				height: t.itemHeight,
				width: t.itemWidth,
				opacity: e
			},
			children: /* @__PURE__ */ V(J, {
				size: Math.min(52, t.itemWidth - 12),
				className: Y.emptyIcon
			})
		}, n))
	});
}
//#endregion
//#region src/spinner/timings.ts
var _t = 300, vt = 2500, yt = 1500, bt = 250, xt = 150, St = 3, Ct = 35, wt = {
	normal: 1500,
	quick: 1e3
};
//#endregion
//#region src/spinner/wheel.ts
function Tt(e, t, n) {
	let r = [];
	for (let i = 0; i < t; i++) {
		let t;
		t = n ? W(n, 1, g) : Math.round(Math.random() * g);
		let i = e[m(e, t) ?? 0];
		i && r.push(i);
	}
	return r;
}
function Et(e, t, n, i) {
	let a = Tt(e.dropTable, t + 5, i).map((t) => ({
		...t,
		rarity: r(t.value, e.priceCents ?? 0),
		chance: u(t.weight ?? 0)
	}));
	return n && a.splice(t, 0, {
		...n,
		rarity: r(n.value, e.priceCents ?? 0),
		chance: a.find((e) => e.itemId === n.itemId)?.chance || u(n.weight ?? 0)
	}), a;
}
//#endregion
//#region src/battle/BattleSpinnerSlot.tsx
var Dt = .45, Ot = A(function({ item: t, isTarget: n, revealed: r, itemHeight: i, itemWidth: o, isHorizontal: s, slotMainSize: l, slotVisualOffset: u, labelGap: d, itemCenter: f, centerProgressDistance: p, containerCenter: m, reelOffset: h, lockDurationSec: g, isAnimating: _ }) {
	let { theme: v, currency: y } = a(), b = n && r, x = te(+!!b), S = (e) => Math.max(0, Math.min(1, 1 - e / p)), C = ne(h, (e) => {
		let t = Math.abs(e + f - m);
		if (s) return `translate3d(0, ${u}px, 0) scale(${st({
			distance: t,
			itemWidth: o
		})})`;
		let r = at(S(t));
		return `translate3d(0, ${n ? u + i / 2 * (1 - r) : u}px, 0) scale(${r})`;
	}), w = ne([h, x], (e) => {
		let t = e[0] ?? 0, r = e[1] ?? 0, i = Math.abs(t + f - m), a = s ? ct({
			distance: i,
			itemWidth: o
		}) : ot(S(i)), c = Math.min(a, .65);
		return n ? c + (1 - c) * r : c;
	}), T = ne(h, (e) => Math.round(S(Math.abs(e + f - m)) * 10));
	N(() => {
		if (!n) {
			x.set(0);
			return;
		}
		let e = ee(x, +!!b, {
			type: "tween",
			duration: Math.min(g, Dt),
			ease: "easeOut"
		});
		return () => e.stop();
	}, [
		n,
		x,
		g,
		b
	]);
	let E = o <= 60;
	return /* @__PURE__ */ H(U.div, {
		className: Y.slot,
		"data-los-target": n ? "true" : void 0,
		style: {
			width: s ? l : "100%",
			height: s ? i : l,
			zIndex: b ? 15 : s ? void 0 : T,
			willChange: _ ? "transform, opacity" : void 0
		},
		children: [n && !s ? /* @__PURE__ */ V(kt, {
			color: c(v.railHex, t.rarity),
			itemWidth: o,
			lockProgress: x
		}) : null, /* @__PURE__ */ H(U.div, {
			className: Y.slotCard,
			style: {
				width: o,
				gap: d,
				transform: C,
				transformOrigin: s ? "center center" : "center top",
				willChange: _ ? "transform" : void 0
			},
			children: [/* @__PURE__ */ V(U.div, {
				className: Y.slotImageFrame,
				style: {
					width: o,
					height: i,
					opacity: w,
					willChange: b || _ ? "opacity" : void 0
				},
				children: t.imageUrl ? /* @__PURE__ */ V("img", {
					"data-los-battle-card": !0,
					src: t.imageUrl,
					alt: t.name,
					loading: "eager",
					decoding: "async",
					width: o,
					height: i,
					className: q(Y.slotImage, b && Y.slotImageRevealed),
					style: { borderRadius: o < 90 ? 4 : 8 }
				}) : /* @__PURE__ */ V("span", {
					"data-los-battle-card": !0,
					"aria-hidden": !0,
					className: Y.slotImageMissing,
					style: { borderRadius: o < 90 ? 4 : 8 }
				})
			}), /* @__PURE__ */ V(U.div, {
				style: { opacity: w },
				children: /* @__PURE__ */ V("span", {
					className: q(Y.slotValue, E && (n ? Y.slotValueCompactTarget : Y.slotValueCompact)),
					children: e(t.value, y, { compact: !0 })
				})
			})]
		})]
	});
});
function kt({ color: e, itemWidth: t, lockProgress: n }) {
	let r = ne(n, (e) => e * .8), i = ft({
		isHorizontal: !1,
		itemWidth: t
	});
	return /* @__PURE__ */ V(U.div, {
		"aria-hidden": !0,
		className: q(Y.glow, Y.glowVertical),
		style: {
			backgroundColor: e,
			height: i.height,
			width: i.width,
			opacity: r
		}
	});
}
function At({ slotOffsets: e, slotMainSizes: t, viewportStart: n, viewportEnd: r, bufferPx: i, bufferStartPx: a = i, bufferEndPx: o = i }) {
	let s = Math.min(e.length, t.length);
	if (s <= 0) return null;
	let c = n - a, l = r + o, u = jt({
		slotOffsets: e,
		slotMainSizes: t,
		slotCount: s,
		startBoundary: c
	}), d = Mt({
		slotOffsets: e,
		slotCount: s,
		endBoundary: l
	});
	if (u < 0 || d < 0 || u > d) {
		let n = e[0] ?? 0, r = s - 1, i = (e[r] ?? 0) + (t[r] ?? 0);
		return l < n ? {
			startIndex: 0,
			endIndex: 0
		} : c > i ? {
			startIndex: r,
			endIndex: r
		} : null;
	}
	return {
		startIndex: u,
		endIndex: d
	};
}
function jt({ slotOffsets: e, slotMainSizes: t, slotCount: n, startBoundary: r }) {
	let i = 0, a = n - 1, o = -1;
	for (; i <= a;) {
		let n = Math.floor((i + a) / 2);
		(e[n] ?? 0) + (t[n] ?? 0) < r ? i = n + 1 : (o = n, a = n - 1);
	}
	return o;
}
function Mt({ slotOffsets: e, slotCount: t, endBoundary: n }) {
	let r = 0, i = t - 1, a = -1;
	for (; r <= i;) {
		let t = Math.floor((r + i) / 2);
		(e[t] ?? 0) > n ? i = t - 1 : (a = t, r = t + 1);
	}
	return a;
}
function Nt({ visibleRange: e, targetIndex: t, slotCount: n, targetOverscanSlots: r = 1 }) {
	if (n <= 0) return [];
	let i = n - 1, a = Rt(t - r, t + r, i);
	return zt([e ? Rt(e.startIndex, e.endIndex, i) : a, a]);
}
function Pt({ visibleRange: e, slotCount: t, stepSlots: n }) {
	if (!e || t <= 0 || n <= 1) return e;
	let r = t - 1;
	return Rt(Math.floor(e.startIndex / n) * n, Math.ceil(e.endIndex / n) * n, r);
}
function Ft({ targetIndex: e, slotCount: t, overscanSlots: n = 6 }) {
	return t <= 0 ? null : Rt(3 - n, e + n, t - 1);
}
function It(e) {
	let t = [], n = /* @__PURE__ */ new Set();
	for (let r of e) for (let e = r.startIndex; e <= r.endIndex; e += 1) n.has(e) || (n.add(e), t.push(e));
	return t;
}
function Lt(e, t) {
	let n = e[0];
	if (n === void 0) return -1;
	if (t <= n) return 0;
	let r = e.length - 1, i = e[r];
	if (i !== void 0 && t >= i) return r;
	let a = 0, o = r;
	for (; a < o;) {
		let n = Math.floor((a + o) / 2);
		(e[n] ?? Infinity) < t ? a = n + 1 : o = n;
	}
	let s = a, c = Math.max(0, s - 1), l = e[c] ?? 0, u = e[s] ?? l;
	return t - l <= u - t ? c : s;
}
function Rt(e, t, n) {
	return {
		startIndex: Math.max(0, Math.min(e, n)),
		endIndex: Math.max(0, Math.min(t, n))
	};
}
function zt(e) {
	let t = e.filter((e) => e.startIndex <= e.endIndex).sort((e, t) => e.startIndex - t.startIndex), n = [];
	for (let e of t) {
		let t = n[n.length - 1];
		if (!t || e.startIndex > t.endIndex + 1) {
			n.push({ ...e });
			continue;
		}
		t.endIndex = Math.max(t.endIndex, e.endIndex);
	}
	return n;
}
//#endregion
//#region src/battle/useBattleSpinnerMeasurement.ts
function Bt(e, t, n) {
	let [r, i] = R(n);
	return F(() => {
		let n = e.current;
		if (!n) return;
		let r = () => {
			let e = n.getBoundingClientRect(), r = t === "horizontal" ? e.width : e.height;
			r > 0 && i(r);
		};
		if (r(), typeof ResizeObserver > "u") return;
		let a = new ResizeObserver(r);
		return a.observe(n), () => a.disconnect();
	}, [e, t]), r || n;
}
//#endregion
//#region src/battle/BattleSpinner.tsx
var Vt = [
	.25,
	.8,
	.5,
	1
], Ht = 160;
function Ut({ box: e, revealedItem: t, prandGenerator: n, running: r, onRevealComplete: i, laneIndex: o, invertSound: s, orientation: l, containerSizeFallback: u, item: d, revealed: f, spinDelayMs: p, spinMs: m, showMs: h, spinItems: g, staggerMs: _, renderBufferSlots: v, renderBufferEndSlots: y, renderWindowStepSlots: b }) {
	let { sounds: x, theme: S } = a(), C = l === "horizontal", w = L(null), T = L(null), E = Bt(w, l, u), { itemHeight: D, itemWidth: O } = d, k = 3 + g, A = (m + o * _) / 1e3, M = h / 1e3, [P] = R(() => e.dropTable.length ? Et(e, k, t, n) : null), F = P?.length ?? k + 2, z = tt({
		isHorizontal: C,
		itemWidth: O
	}), B = I(() => Array.from({ length: F }, (e, t) => et({
		index: t,
		endingItemIdx: k,
		isHorizontal: C,
		itemHeight: D,
		itemWidth: O
	})), [
		F,
		k,
		C,
		D,
		O
	]), W = I(() => $e(B, z), [B, z]), re = I(() => W.map((e, t) => rt({
		offset: e,
		index: t,
		endingItemIdx: k,
		isHorizontal: C,
		itemHeight: D,
		itemWidth: O,
		slotMainSize: B[t] ?? D
	})), [
		W,
		k,
		C,
		D,
		O,
		B
	]), G = C ? E / 2 : 68 + D / 2, ie = G - (re[k] ?? 0), K = G - (re[3] ?? W[3] ?? 0), ae = C ? O + z : it(D), oe = I(() => {
		let e = F - 1;
		return (W[e] ?? 0) + (B[e] ?? 0);
	}, [
		F,
		W,
		B
	]), se = (I(() => B.reduce((e, t) => Math.max(e, t), 0), [B]) || (C ? O : D)) + z, ce = se * v, le = se * y, J = j((e) => Pt({
		visibleRange: At({
			slotOffsets: W,
			slotMainSizes: B,
			viewportStart: -e,
			viewportEnd: E - e,
			bufferPx: ce,
			bufferEndPx: le
		}),
		slotCount: F,
		stepSlots: b
	}), [
		E,
		le,
		ce,
		b,
		W,
		B,
		F
	]), [ue, de] = R(() => J(f ? ie : K)), fe = L(ue), pe = j((e) => {
		let t = J(e), n = fe.current;
		(n?.startIndex !== t?.startIndex || n?.endIndex !== t?.endIndex) && (fe.current = t, de(t));
	}, [J]), me = I(() => P ? It(Nt({
		visibleRange: ue,
		targetIndex: k,
		slotCount: F
	})).flatMap((e) => {
		let t = P[e];
		return t ? [{
			card: t,
			index: e
		}] : [];
	}) : [], [
		P,
		ue,
		k,
		F
	]);
	N(() => {
		if (!P || typeof Image > "u") return;
		let e = Ft({
			targetIndex: k,
			slotCount: F
		});
		if (!e) return;
		let t = /* @__PURE__ */ new Set();
		for (let n = e.startIndex; n <= e.endIndex; n += 1) {
			let e = P[n]?.imageUrl;
			!e || t.has(e) || (t.add(e), new Image().src = e);
		}
	}, [
		P,
		k,
		F
	]);
	let [he, ge] = R(!1);
	N(() => {
		if (!P || he) return;
		let e = !1, t = () => {
			e || ge(!0);
		};
		return Kt().then(() => {
			if (e) return;
			let n = T.current;
			if (!n) return t();
			let r = Array.from(n.querySelectorAll("img[data-los-battle-card]"));
			Promise.race([Promise.all(r.map(Gt)).catch(() => void 0), qt(Ht)]).then(Kt).then(Kt).then(t);
		}), () => {
			e = !0;
		};
	}, [P, he]);
	let [_e, ve] = R("idle"), ye = L(!1), be = L(null), xe = L(null);
	N(() => {
		r && (ye.current = !1, be.current = performance.now(), xe.current &&= (clearTimeout(xe.current), null), ve("spinning"));
	}, [r]), N(() => () => {
		xe.current && clearTimeout(xe.current);
	}, []);
	let Se = te(K), Ce = ne(Se, (e) => C ? `translate3d(${e}px, 0, 0)` : `translate3d(0, ${e}px, 0)`), we = L(0), Te = L(null), Ee = j((e) => {
		if (!P) return;
		let t = Date.now();
		if (t - we.current < 16) return;
		let n = Lt(re, G - e);
		n === Te.current || n < 0 || n >= P.length || (Te.current = n, we.current = t, x.playTickSound());
	}, [
		P,
		re,
		G,
		x
	]), De = () => {
		if (ye.current) return;
		ye.current = !0;
		let e = P?.[k]?.rarity ?? 0;
		x.playRaritySound(s ? Wt(e) : e), i(e);
	}, Oe = L(De);
	Oe.current = De, N(() => {
		if (_e !== "spinning") {
			Se.set(K), pe(K);
			return;
		}
		let e = p + m + o * _ - 50, t = ee(Se.get(), ie, {
			type: "tween",
			duration: A,
			delay: p / 1e3,
			ease: Vt,
			onUpdate: (e) => {
				Se.set(e), pe(e), o === 0 && Ee(e);
			},
			onComplete: () => {
				if (ye.current) return;
				let t = be.current, n = t === null ? e : performance.now() - t;
				if (n < e) {
					xe.current = setTimeout(() => Oe.current(), e - n);
					return;
				}
				Oe.current();
			}
		});
		return () => t.stop();
	}, [
		_e,
		Se,
		K,
		ie,
		A,
		p,
		m,
		_,
		o,
		Ee,
		pe
	]), N(() => {
		f && pe(ie);
	}, [
		f,
		ie,
		pe
	]);
	let ke = te(+!!f), Ae = ne(ke, (e) => e * .8);
	if (N(() => {
		let e = ee(ke, +!!f, {
			type: "tween",
			duration: Math.min(M, .45),
			ease: "easeOut"
		});
		return () => e.stop();
	}, [
		ke,
		M,
		f
	]), !P) return null;
	let je = P[k], Me = ft({
		isHorizontal: !0,
		itemWidth: O
	});
	return /* @__PURE__ */ H("div", {
		ref: w,
		className: Y.reelViewport,
		children: [
			C && f && je ? /* @__PURE__ */ V(U.div, {
				"aria-hidden": !0,
				className: q(Y.glow, O <= 80 && Y.glowSmall),
				style: {
					backgroundColor: c(S.railHex, je.rarity),
					height: Me.height,
					width: Me.width,
					top: pt(O),
					opacity: Ae
				}
			}) : null,
			he ? null : /* @__PURE__ */ V(gt, {
				orientation: l,
				item: d
			}),
			/* @__PURE__ */ V("div", {
				className: q(Y.reelClip, C && Y.reelClipHorizontal),
				children: /* @__PURE__ */ V(U.div, {
					ref: T,
					"data-los-battle-reel": !0,
					"data-los-lane": o,
					className: q(Y.reel, !C && Y.reelVertical),
					style: {
						...C ? {
							height: D,
							width: oe
						} : { height: oe },
						transform: Ce,
						willChange: _e === "spinning" ? "transform" : void 0,
						opacity: he ? 1 : .001
					},
					children: me.map(({ card: e, index: t }) => /* @__PURE__ */ V("div", {
						"data-los-slot-index": t,
						className: Y.slotAnchor,
						style: C ? {
							left: W[t] ?? 0,
							top: 0
						} : {
							left: 0,
							top: W[t] ?? 0,
							width: "100%"
						},
						children: /* @__PURE__ */ V(Ot, {
							item: e,
							isTarget: t === k,
							revealed: t === k && f,
							itemHeight: D,
							itemWidth: O,
							isHorizontal: C,
							slotMainSize: B[t] ?? D,
							slotVisualOffset: nt({
								index: t,
								endingItemIdx: k,
								isHorizontal: C,
								itemWidth: O
							}),
							labelGap: mt({
								index: t,
								endingItemIdx: k,
								isHorizontal: C,
								itemWidth: O
							}),
							itemCenter: re[t] ?? 0,
							centerProgressDistance: ae,
							containerCenter: G,
							reelOffset: Se,
							lockDurationSec: M,
							isAnimating: _e === "spinning" || f
						})
					}, `${t}-${e.itemId}`))
				})
			})
		]
	});
}
function Wt(e) {
	return e >= 4 ? 0 : e <= 1 ? 4 : e;
}
function Gt(e) {
	return e.complete && e.naturalWidth > 0 ? Promise.resolve() : typeof e.decode == "function" ? e.decode().catch(() => void 0) : new Promise((t) => {
		let n = () => {
			e.removeEventListener("load", n), e.removeEventListener("error", n), t();
		};
		e.addEventListener("load", n, { once: !0 }), e.addEventListener("error", n, { once: !0 });
	});
}
function Kt() {
	return new Promise((e) => {
		if (typeof requestAnimationFrame > "u") {
			setTimeout(e, 0);
			return;
		}
		requestAnimationFrame(() => e());
	});
}
function qt(e) {
	return new Promise((t) => {
		setTimeout(t, e);
	});
}
//#endregion
//#region src/battle/BattleSpinnerChrome.tsx
var Jt = {
	default: {
		left: {
			top: 25,
			bottom: 25,
			width: 18
		},
		right: {
			top: 25,
			bottom: 25,
			width: 18
		}
	},
	"desktop-compact": {
		left: {
			top: 0,
			bottom: 0,
			width: 37
		},
		right: {
			top: 0,
			bottom: 0,
			width: 37
		}
	},
	"mobile-2p": {
		left: {
			top: 0,
			height: 190,
			width: 37
		},
		right: {
			top: 0,
			height: 190,
			width: 37
		}
	},
	"mobile-3p": {
		left: {
			top: 5,
			height: 95,
			width: 12
		},
		right: {
			top: 0,
			height: 100,
			width: 12
		}
	},
	"mobile-grid": {
		left: {
			top: 0,
			height: 137,
			width: 12
		},
		right: {
			top: 0,
			height: 137,
			width: 12
		}
	}
};
function Yt({ orientation: e, variant: t }) {
	if (e === "vertical") return /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: q(Y.fade, Y.fadeTop)
	}), /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: q(Y.fade, Y.fadeBottom)
	})] });
	let n = Jt[t];
	return /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: q(Y.fade, Y.fadeLeft),
		style: n.left
	}), /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: q(Y.fade, Y.fadeRight),
		style: n.right
	})] });
}
//#endregion
//#region src/battle/BattleRarityFrame.tsx
function Xt({ orientation: e, variant: t, color: n, inset: r = 0, endInset: i, side: a = "both", className: o }) {
	let s = i ?? r;
	if (e === "vertical") return /* @__PURE__ */ H("div", {
		"aria-hidden": !0,
		className: q(Y.frame, o),
		children: [a === "end" ? null : /* @__PURE__ */ V($t, {
			className: q(Y.rail, Y.railStartVertical),
			color: n,
			style: { left: r }
		}), a === "start" ? null : /* @__PURE__ */ V($t, {
			className: q(Y.rail, Y.railEndVertical),
			color: n,
			style: { right: s }
		})]
	});
	let c = t === "desktop" ? Qt : Zt, l = t === "desktop";
	return /* @__PURE__ */ H("div", {
		"aria-hidden": !0,
		className: q(Y.frame, o),
		children: [a === "end" ? null : /* @__PURE__ */ V(c, {
			className: q(Y.rail, l ? Y.railStartHorizontalFlipped : Y.railStartHorizontal),
			color: n,
			style: { top: r }
		}), a === "start" ? null : /* @__PURE__ */ V(c, {
			className: q(Y.rail, l ? Y.railEndHorizontal : Y.railEndHorizontalFlipped),
			color: n,
			style: { bottom: s }
		})]
	});
}
function Zt({ className: e, color: t, style: n }) {
	let r = tn();
	return /* @__PURE__ */ H("svg", {
		"aria-hidden": "true",
		className: e,
		width: "62",
		height: "9",
		viewBox: "0 0 62 9",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ V("path", {
			d: "M62 0.611684L36.1139 0.501953L31.0527 7.50195L25.929 0.503092M0 0.611395L12.6531 0.611684L25.929 0.503092L31.0527 4.75195L36.1139 0.503092",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ V(en, {
			id: r,
			color: t,
			length: "62"
		})]
	});
}
function Qt({ className: e, color: t, style: n }) {
	let r = tn();
	return /* @__PURE__ */ H("svg", {
		"aria-hidden": "true",
		className: e,
		width: "74",
		height: "14",
		viewBox: "0 0 74 14",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ V("path", {
			d: "M0.00390625 13.3119L30.6914 13.5L36.6914 1.49988L42.7655 13.498M73.5039 13.3124L58.5039 13.3119L42.7655 13.498L36.6914 4.49988L30.6914 13.498",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ V(en, {
			id: r,
			color: t,
			length: "74"
		})]
	});
}
function $t({ className: e, color: t, style: n }) {
	let r = tn();
	return /* @__PURE__ */ H("svg", {
		"aria-hidden": "true",
		className: e,
		width: "14",
		height: "74",
		viewBox: "0 0 14 74",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ V("path", {
			d: "M0.688111 0.00390625L0.5 30.6914L12.5001 36.6914L0.501953 42.7655M0.687616 73.5039L0.688111 58.5039L0.501953 42.7655L9.50012 36.6914L0.501953 30.6914",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ V("defs", { children: /* @__PURE__ */ H("linearGradient", {
			id: r,
			x1: "6.75",
			y1: "0",
			x2: "6.75",
			y2: "74",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ V("stop", {
					stopColor: t,
					stopOpacity: "0"
				}),
				/* @__PURE__ */ V("stop", {
					offset: "0.5",
					stopColor: t
				}),
				/* @__PURE__ */ V("stop", {
					offset: "1",
					stopColor: t,
					stopOpacity: "0"
				})
			]
		}) })]
	});
}
function en({ id: e, color: t, length: n }) {
	return /* @__PURE__ */ V("defs", { children: /* @__PURE__ */ H("linearGradient", {
		id: e,
		x1: n,
		y1: "4.15",
		x2: "0",
		y2: "4.15",
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ V("stop", {
				stopColor: t,
				stopOpacity: "0"
			}),
			/* @__PURE__ */ V("stop", {
				offset: "0.5",
				stopColor: t
			}),
			/* @__PURE__ */ V("stop", {
				offset: "1",
				stopColor: t,
				stopOpacity: "0"
			})
		]
	}) });
}
function tn() {
	return `los-battle-frame-${P().replace(/:/g, "")}`;
}
//#endregion
//#region src/battle/BattleSpinnerPointers.tsx
function nn({ orientation: e, color: t, compact: n, config: r }) {
	return e === "horizontal" ? n ? r.compactEdgePointers ? /* @__PURE__ */ V(Xt, {
		orientation: "horizontal",
		variant: "mobile",
		color: t,
		inset: r.compactEdgeInset ?? 42,
		endInset: r.compactEdgeEndInset ?? 6
	}) : /* @__PURE__ */ V(Xt, {
		orientation: "horizontal",
		variant: "mobile",
		color: t,
		inset: 12
	}) : /* @__PURE__ */ V(Xt, {
		orientation: "horizontal",
		variant: "desktop",
		color: t,
		inset: r.horizontalInset ?? 56,
		endInset: r.horizontalEndInset ?? 12
	}) : /* @__PURE__ */ V(Xt, {
		orientation: "vertical",
		variant: "desktop",
		color: t,
		inset: r.verticalInset ?? 12
	});
}
//#endregion
//#region src/battle/BattleSeatColumn.tsx
function rn({ seatIndex: e, layout: t, box: n, revealedItem: i, prandGenerator: o, reelKey: s, running: l, revealed: u, invertSound: d, timings: f, header: p, rowIndex: m, isLastInRow: h, isLastRow: g, onRevealComplete: _ }) {
	let { theme: v } = a(), { spinner: y, columnVariant: b, headerAlign: x } = t, S = y.orientation === "horizontal", C = n !== null && i !== null && n.dropTable.length > 0, w = u && n && i ? c(v.railHex, r(i.value, n.priceCents)) : v.colors.border, T = j((t) => _(e, t), [_, e]), E = b === "mobile-grid", D = b === "mobile-2p" || b === "mobile-3p";
	return /* @__PURE__ */ V("div", {
		className: q(Y.column, h && Y.columnLastInRow, g && Y.columnLastRow, b !== "default" && Y.columnGrid),
		style: an({
			columnVariant: b,
			rowIndex: m,
			isLastRow: g
		}),
		"data-los-battle-seat": e,
		children: /* @__PURE__ */ H("div", {
			className: q(Y.columnInner, E && Y.columnInnerGrid, D && Y.columnInnerCompact, x === "right" && Y.columnInnerBare),
			children: [
				/* @__PURE__ */ V("div", {
					className: q(Y.header, x === "right" && Y.headerRight, x === "compact" && Y.headerCompact),
					children: p
				}),
				/* @__PURE__ */ V(nn, {
					orientation: y.orientation,
					color: w,
					compact: x === "compact",
					config: y.pointers
				}),
				/* @__PURE__ */ H("div", {
					className: q(Y.viewport, S ? Y.viewportHorizontal : Y.viewportVertical, y.viewport.position === "absolute-top" && Y.viewportAbsoluteTop, y.viewport.position === "absolute-center" && Y.viewportAbsoluteCenter),
					style: on(y.viewport),
					children: [/* @__PURE__ */ V(Yt, {
						orientation: y.orientation,
						variant: y.chrome
					}), C ? /* @__PURE__ */ V(Ut, {
						box: n,
						revealedItem: i,
						prandGenerator: o,
						running: l,
						onRevealComplete: T,
						laneIndex: e,
						invertSound: d,
						orientation: y.orientation,
						containerSizeFallback: S ? 190 : y.viewport.height,
						item: y.item,
						revealed: u,
						spinDelayMs: f.spinDelayMs,
						spinMs: f.spinMs,
						showMs: f.showMs,
						spinItems: f.spinItems,
						staggerMs: f.staggerMs,
						renderBufferSlots: y.renderBufferSlots,
						renderBufferEndSlots: y.renderBufferEndSlots,
						renderWindowStepSlots: y.renderWindowStepSlots
					}, s) : /* @__PURE__ */ V(gt, {
						orientation: y.orientation,
						item: y.item
					})]
				})
			]
		})
	});
}
function an({ columnVariant: e, rowIndex: t, isLastRow: n }) {
	switch (e) {
		case "default": return { padding: 6 };
		case "mobile-2p": return { padding: `${t === 0 ? 6 : 3}px 6px ${n ? 6 : 3}px` };
		case "mobile-3p": return { padding: `${t === 0 ? 5 : 3}px 5px ${n ? 6 : 3}px` };
		case "mobile-grid": return { padding: 0 };
	}
}
function on(e) {
	let t = e.marginX ?? 0, n = {
		width: t < 0 && e.width === "100%" ? `calc(100% + ${-2 * t}px)` : e.width,
		height: e.height,
		maxWidth: t < 0 ? "none" : void 0
	};
	return e.position === "flow" && (n.marginTop = e.marginTop, n.marginLeft = t || void 0, n.marginRight = t || void 0), e.position === "absolute-top" && (n.top = e.top), n;
}
//#endregion
//#region src/battle/battleLayout.ts
var sn = 768, cn = {
	itemWidth: 128,
	itemHeight: 176
}, ln = {
	itemWidth: 138,
	itemHeight: 190
}, un = {
	itemWidth: 81,
	itemHeight: 112
}, dn = {
	itemWidth: 94,
	itemHeight: 130
}, fn = {
	itemWidth: 58,
	itemHeight: 80
}, pn = {
	itemWidth: 71,
	itemHeight: 98
}, mn = { verticalInset: 24 }, hn = {
	horizontalInset: 56,
	horizontalEndInset: 12
}, gn = {
	horizontalInset: 12,
	horizontalEndInset: 12
}, _n = {
	compactEdgePointers: !0,
	compactEdgeInset: 42,
	compactEdgeEndInset: 6
}, vn = {
	..._n,
	compactEdgeInset: 6
}, yn = {
	renderBufferSlots: 0,
	renderBufferEndSlots: 2,
	renderWindowStepSlots: 2
}, bn = {
	renderBufferSlots: 2,
	renderBufferEndSlots: 2,
	renderWindowStepSlots: 1
}, xn = {
	width: "100%",
	height: 124,
	position: "absolute-top",
	top: 54
};
function Sn(e) {
	return !e || e < 2 ? 2 : e >= 5 ? 6 : e;
}
function Cn(e) {
	let t = Sn(e.playerCount), n = `ffa-${t}`;
	return e.viewport === "mobile" ? Tn(n, t) : wn(n, t);
}
function wn(e, t) {
	let n = {
		key: e,
		viewport: "desktop",
		playerCount: t,
		gap: 0,
		padding: 0
	};
	switch (e) {
		case "ffa-2": return {
			...n,
			columns: 2,
			rows: 1,
			height: 380,
			dividerMode: "adjacent",
			columnVariant: "default",
			headerAlign: "center",
			showHeaderTotal: !1,
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: 552,
					height: 188,
					position: "flow",
					marginTop: 38
				},
				item: cn,
				pointers: hn,
				chrome: "default",
				...yn
			},
			results: { cardsPerRow: 4 }
		};
		case "ffa-3": return {
			...n,
			columns: 3,
			rows: 1,
			height: 440,
			dividerMode: "adjacent",
			columnVariant: "default",
			headerAlign: "center",
			showHeaderTotal: !1,
			spinner: {
				orientation: "vertical",
				viewport: {
					width: 402.67,
					height: 364,
					position: "flow"
				},
				item: ln,
				pointers: mn,
				chrome: "default",
				...yn
			},
			results: { cardsPerRow: 3 }
		};
		case "ffa-4": return {
			...n,
			columns: 4,
			rows: 1,
			height: 440,
			dividerMode: "adjacent",
			columnVariant: "default",
			headerAlign: "center",
			showHeaderTotal: !1,
			spinner: {
				orientation: "vertical",
				viewport: {
					width: 293,
					height: 364,
					position: "flow"
				},
				item: ln,
				pointers: mn,
				chrome: "default",
				...yn
			},
			results: { cardsPerRow: 2 }
		};
		case "ffa-6": return {
			...n,
			columns: 2,
			rows: 3,
			height: 726,
			dividerMode: "two-column-rows",
			columnVariant: "default",
			headerAlign: "right",
			showHeaderTotal: !1,
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: 449,
					height: 137,
					position: "absolute-center"
				},
				item: un,
				pointers: gn,
				chrome: "desktop-compact",
				...yn
			},
			results: { cardsPerRow: 1 }
		};
	}
}
function Tn(e, t) {
	let n = {
		key: e,
		viewport: "mobile",
		playerCount: t,
		headerAlign: "compact",
		showHeaderTotal: !0,
		results: { cardsPerRow: 2 }
	};
	switch (e) {
		case "ffa-2": return {
			...n,
			columns: 1,
			rows: 2,
			height: 439,
			gap: 0,
			padding: 0,
			dividerMode: "none",
			columnVariant: "mobile-2p",
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: "100%",
					height: 152,
					position: "flow",
					marginTop: -5,
					marginX: -7
				},
				item: dn,
				pointers: {},
				chrome: "mobile-2p",
				...bn
			}
		};
		case "ffa-3": return {
			...n,
			columns: 1,
			rows: 3,
			height: 440,
			gap: 0,
			padding: 0,
			dividerMode: "none",
			columnVariant: "mobile-3p",
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: 336,
					height: 104,
					position: "flow",
					marginTop: -14
				},
				item: fn,
				pointers: vn,
				chrome: "mobile-3p",
				...bn
			}
		};
		case "ffa-4": return {
			...n,
			columns: 2,
			rows: 2,
			height: 420,
			gap: 6,
			padding: 6,
			dividerMode: "center",
			columnVariant: "mobile-grid",
			spinner: {
				orientation: "horizontal",
				viewport: xn,
				item: pn,
				pointers: _n,
				chrome: "mobile-grid",
				...bn
			}
		};
		case "ffa-6": return {
			...n,
			columns: 2,
			rows: 3,
			height: 610,
			gap: 6,
			padding: 6,
			dividerMode: "two-column-rows",
			columnVariant: "mobile-grid",
			spinner: {
				orientation: "horizontal",
				viewport: xn,
				item: pn,
				pointers: _n,
				chrome: "mobile-grid",
				...bn
			}
		};
	}
}
//#endregion
//#region src/battle/battleTimings.ts
var En = 3e3, Dn = [
	2,
	3,
	4,
	6
], On = 250, kn = 300, An = {
	spinMs: vt,
	quickSpinMs: yt,
	staggerMs: 250,
	quickStaggerMs: 150,
	spinLeadMs: 250 + kn,
	showMs: 1e3,
	holdMs: wt.normal,
	quickHoldMs: wt.quick
};
function jn(e) {
	let t = An, n = e.fastSpin ? t.quickSpinMs : t.spinMs, r = e.fastSpin ? t.quickStaggerMs : t.staggerMs, i = e.fastSpin ? t.quickHoldMs : t.holdMs;
	return t.spinLeadMs + n + r * Math.max(0, e.playerCount - 1) + t.showMs + i;
}
function Mn(e) {
	let t = An, n = e.fastSpin ? t.quickSpinMs : t.spinMs, r = e.fastSpin ? t.quickStaggerMs : t.staggerMs;
	return t.spinLeadMs + n + r * Math.max(0, e.laneCount - 1) + t.showMs;
}
function Nn(e) {
	return e.compact ? e.fastSpin ? 10 : 14 : 24;
}
//#endregion
//#region src/battle/BattleOpener.tsx
function Pn(e) {
	let t = ae(), n = e.theme ?? t.theme, r = e.currency ?? t.currency ?? i, a = e.locale ?? t.locale, s = I(() => C(a), [a]), c = I(() => o(n), [n]), l = le({
		sounds: t.sounds,
		soundBaseUrl: t.soundBaseUrl
	}), u = e.sounds ?? l, d = e.quick ?? !1, f = e.invertSound ?? !1, p = e.laneItems.length, m = L(null), [h, g] = R(null);
	F(() => {
		let e = m.current;
		if (!e) return;
		let t = () => g(e.offsetWidth);
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, []);
	let y = e.compact ?? "auto", b = y === "auto" ? h !== null && h < 768 : y, x = I(() => Cn({
		playerCount: p,
		viewport: b ? "mobile" : "desktop"
	}), [p, b]), S = I(() => {
		let e = An;
		return {
			spinDelayMs: 250,
			spinMs: d ? e.quickSpinMs : e.spinMs,
			showMs: e.showMs,
			spinItems: Nn({
				fastSpin: d,
				compact: b
			}),
			staggerMs: d ? e.quickStaggerMs : e.staggerMs
		};
	}, [d, b]), w = e.seed, T = I(() => Array.from({ length: p }, (e, t) => v(w, t)), [w, p]), [E, D] = R(() => /* @__PURE__ */ new Set()), O = e.onLaneSettled, k = j((e, t) => {
		D((t) => {
			if (t.has(e)) return t;
			let n = new Set(t);
			return n.add(e), n;
		}), O?.(e, t);
	}, [O]), A = p > 0 && E.size >= p, M = e.onRevealComplete, P = L(M);
	P.current = M;
	let z = L(!1);
	N(() => {
		if (!A || z.current) return;
		let e = setTimeout(() => {
			z.current = !0, P.current?.();
		}, kn + S.showMs);
		return () => clearTimeout(e);
	}, [A, S.showMs]);
	let B = I(() => ({
		strings: s,
		theme: c,
		sounds: u,
		currency: r
	}), [
		s,
		c,
		u,
		r
	]), ee = {
		gridTemplateColumns: `repeat(${x.columns}, minmax(0, 1fr))`,
		height: x.height,
		gap: x.gap,
		padding: x.padding
	};
	return /* @__PURE__ */ V(_.Provider, {
		value: B,
		children: /* @__PURE__ */ H("div", {
			ref: m,
			className: q(Y.root, e.className),
			style: {
				...c.cssVars,
				...e.style
			},
			"data-los-battle-opener": !0,
			"data-los-battle-layout": x.key,
			"data-los-battle-viewport": x.viewport,
			children: [h === null && y === "auto" ? null : /* @__PURE__ */ H("div", {
				className: Y.grid,
				style: ee,
				children: [e.laneItems.map((t, n) => {
					let r = Math.floor(n / x.columns), i = E.has(n);
					return /* @__PURE__ */ V(rn, {
						seatIndex: n,
						layout: x,
						box: e.box,
						revealedItem: t,
						prandGenerator: T[n] ?? v(w, n),
						reelKey: `${w}:${n}`,
						running: e.running,
						revealed: i,
						invertSound: f,
						timings: S,
						header: e.renderSeatHeader?.(n, {
							compact: b,
							settled: i,
							layout: x
						}),
						rowIndex: r,
						isLastInRow: (n + 1) % x.columns === 0 || n === p - 1,
						isLastRow: r === x.rows - 1,
						onRevealComplete: k
					}, n);
				}), /* @__PURE__ */ V(ue, { layout: x })]
			}), e.overlay]
		})
	});
}
//#endregion
//#region src/battle/BattleResultsGrid.tsx
function Fn(t) {
	let n = ae(), r = I(() => o(t.theme ?? n.theme), [t.theme, n.theme]), a = t.currency ?? n.currency ?? i, s = I(() => C(t.locale ?? n.locale), [t.locale, n.locale]), c = L(null), [l, u] = R(null);
	F(() => {
		let e = c.current;
		if (!e) return;
		let t = () => u(e.offsetWidth);
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, []);
	let d = t.compact ?? "auto", f = d === "auto" ? l !== null && l < 768 : d, p = Cn({
		playerCount: t.lanes.length,
		viewport: f ? "mobile" : "desktop"
	}).results.cardsPerRow, m = I(() => Array.from({ length: t.roundCount }, (e, t) => t), [t.roundCount]), h = (e, n) => {
		let i = e.items[n] ?? null;
		return i ? /* @__PURE__ */ V(In, {
			item: i,
			priceCents: t.roundPriceCents[n] ?? 0,
			theme: r,
			currency: a
		}, n) : /* @__PURE__ */ H("div", {
			className: q(Y.resultCard, Y.resultPlaceholder),
			title: `${s.battleRound} ${n + 1}`,
			children: [/* @__PURE__ */ V("p", {
				className: Y.resultPlaceholderLabel,
				children: s.battleRound.toUpperCase()
			}), /* @__PURE__ */ V("p", {
				className: Y.resultPlaceholderNumber,
				children: String(n + 1).padStart(2, "0")
			})]
		}, n);
	};
	return /* @__PURE__ */ V("div", {
		ref: c,
		className: q(Y.root, t.className),
		style: {
			...r.cssVars,
			...t.style
		},
		"data-los-battle-results": !0,
		children: l === null && d === "auto" ? null : f ? /* @__PURE__ */ V("div", {
			className: Y.resultsMobile,
			children: t.lanes.map((n, r) => /* @__PURE__ */ H("div", {
				className: Y.resultsMobileSeat,
				children: [/* @__PURE__ */ H("div", {
					className: Y.resultsMobileHeader,
					children: [t.renderSeatHeader(r, { compact: !0 }), /* @__PURE__ */ V("span", {
						className: Y.resultsMobileTotal,
						children: n.totalCents > 0 ? e(n.totalCents, a) : "-"
					})]
				}), /* @__PURE__ */ V("div", {
					className: Y.resultsMobileStrip,
					children: m.map((e) => h(n, e))
				})]
			}, r))
		}) : /* @__PURE__ */ V("div", {
			className: Y.results,
			style: { gridTemplateColumns: `repeat(${t.lanes.length}, minmax(0, 1fr))` },
			children: t.lanes.map((n, r) => /* @__PURE__ */ H("div", {
				className: Y.resultsSeat,
				children: [/* @__PURE__ */ H("div", {
					className: Y.resultsHeader,
					children: [t.renderSeatHeader(r, { compact: !1 }), /* @__PURE__ */ V("div", {
						className: Y.resultsTotal,
						children: n.totalCents > 0 ? e(n.totalCents, a) : "-"
					})]
				}), /* @__PURE__ */ V("div", {
					className: Y.resultsCards,
					style: { gridTemplateColumns: `repeat(${p}, minmax(0, 1fr))` },
					children: m.map((e) => h(n, e))
				})]
			}, r))
		})
	});
}
function In({ item: t, priceCents: n, theme: i, currency: a }) {
	let o = c(i.railHex, r(t.value, n));
	return /* @__PURE__ */ H(U.div, {
		className: Y.resultCard,
		style: { borderColor: o },
		initial: {
			opacity: 0,
			scale: .92
		},
		animate: {
			opacity: 1,
			scale: 1
		},
		transition: {
			type: "tween",
			duration: .35,
			ease: "easeOut"
		},
		title: t.name,
		children: [
			t.imageUrl ? /* @__PURE__ */ V("img", {
				className: Y.resultCardImage,
				src: t.imageUrl,
				alt: t.name,
				loading: "eager",
				decoding: "async"
			}) : /* @__PURE__ */ V("span", {
				"aria-hidden": !0,
				className: q(Y.resultCardImage, Y.resultCardImageMissing)
			}),
			/* @__PURE__ */ V("p", {
				className: Y.resultCardName,
				children: t.name
			}),
			/* @__PURE__ */ V("span", {
				className: Y.resultCardValue,
				style: { color: o },
				children: e(t.value, a, { compact: !0 })
			})
		]
	});
}
//#endregion
//#region src/battle/BattleStartingOverlay.tsx
var Ln = 240;
function Rn({ endsAtMs: e, now: t = Date.now, onFinished: n, children: r, className: i }) {
	let { strings: o } = a(), [s, c] = R(() => Math.max(0, e - t())), l = L(!1);
	N(() => {
		l.current = !1;
		let r = () => {
			let r = Math.max(0, e - t());
			c(r), r <= 0 && !l.current && (l.current = !0, n());
		};
		r();
		let i = setInterval(r, 50);
		return () => clearInterval(i);
	}, [
		e,
		t,
		n
	]);
	let u = Math.ceil(s / 1e3), d = u > 0 ? String(u) : o.battleGo, f = s <= Ln;
	return /* @__PURE__ */ H(U.div, {
		className: q(Y.starting, i),
		"data-los-battle-starting": !0,
		initial: !1,
		animate: {
			filter: f ? "blur(18px)" : "blur(0px)",
			opacity: +!f,
			scale: f ? 1.015 : 1
		},
		transition: {
			duration: f ? Ln / 1e3 : 0,
			ease: "easeInOut"
		},
		children: [
			/* @__PURE__ */ V("span", {
				className: Y.startingLabel,
				children: o.battleStartsIn
			}),
			/* @__PURE__ */ V("div", {
				className: Y.startingCount,
				"aria-live": "polite",
				children: /* @__PURE__ */ V(U.span, {
					className: q(Y.startingDigit, u <= 0 && Y.startingGo),
					initial: {
						scale: 1.6,
						opacity: 0
					},
					animate: {
						scale: 1,
						opacity: 1
					},
					transition: {
						type: "tween",
						duration: .25,
						ease: "easeOut"
					},
					children: d
				}, d)
			}),
			/* @__PURE__ */ V("span", {
				className: q(Y.startingLabel, Y.startingLuck),
				children: o.battleGoodLuck
			}),
			r ? /* @__PURE__ */ V("div", {
				className: Y.startingSeats,
				children: r
			}) : null
		]
	});
}
//#endregion
//#region src/core/machine.ts
var zn = 700;
function Bn(e) {
	let { openBox: t, onBeforeOpen: n, revealStartDelayMs: r = 700, minQuantity: i = 1, maxQuantity: a = 5, onEvent: o } = e, s = (e) => Math.max(i, Math.min(a, Math.floor(e) || i)), c = {
		phase: "idle",
		quantity: s(e.defaultQuantity ?? i),
		isQuickReveal: e.defaultQuickReveal ?? !1,
		entries: [],
		lastResponse: null,
		claimStatus: "none",
		pendingClaim: null,
		claim: null,
		claimError: null,
		sale: null,
		sellError: null,
		error: null,
		openCount: 0
	}, l = /* @__PURE__ */ new Set(), u = null, d = 0, f = !1, p = (e) => o?.(e), m = (e) => {
		c = {
			...c,
			...e
		};
		for (let e of l) e();
	}, h = () => {
		u !== null && (clearTimeout(u), u = null);
	}, g = (e) => {
		c.phase === "revealing" && (m({
			phase: "results",
			openCount: c.openCount + 1
		}), e && p({ type: "skipped" }), p({
			type: "reveal_complete",
			response: c.lastResponse,
			skipped: e
		}));
	};
	return {
		getState: () => c,
		subscribe: (e) => (l.add(e), () => l.delete(e)),
		open: async (i = c.quantity) => {
			if (f || c.phase !== "idle") return;
			let a = s(i), o = ++d;
			if (n) {
				let e;
				try {
					e = await n(a);
				} catch {
					e = !1;
				}
				if (e === !1) {
					p({
						type: "open_vetoed",
						quantity: a
					});
					return;
				}
				if (o !== d || c.phase !== "idle") return;
			}
			m({
				phase: "requesting",
				quantity: a,
				entries: [],
				claimStatus: "none",
				pendingClaim: null,
				claim: null,
				claimError: null,
				sale: null,
				sellError: null,
				error: null
			}), p({
				type: "open_start",
				quantity: a
			});
			let l;
			try {
				l = await t(a);
			} catch (e) {
				if (o !== d) return;
				m({
					phase: "idle",
					error: e
				}), p({
					type: "error",
					error: e
				});
				return;
			}
			if (o !== d) return;
			p({
				type: "opened",
				response: l
			});
			let h = () => {
				u = null;
				let t = l.status !== "claimed" && !!e.claimReveal;
				m({
					phase: "revealing",
					entries: l.entries,
					lastResponse: l,
					claimStatus: l.status === "claimed" ? "claimed" : t ? "unclaimed" : "none",
					pendingClaim: t ? {
						openGroupId: l.openGroupId,
						costCents: l.costCents
					} : null,
					claim: l.claim
				}), p({
					type: "reveal_start",
					response: l
				});
			};
			r > 0 ? u = setTimeout(h, r) : h();
		},
		skip: () => g(!0),
		completeReveal: () => g(!1),
		claim: async () => {
			if (f || !e.claimReveal || c.phase !== "results" || c.claimStatus !== "unclaimed") return;
			let t = c.pendingClaim;
			if (!t) return;
			let n = d;
			m({
				claimStatus: "claiming",
				claimError: null,
				sellError: null
			}), p({
				type: "claim_start",
				openGroupId: t.openGroupId
			});
			let r;
			try {
				r = await e.claimReveal(t);
			} catch (e) {
				if (n !== d) return;
				m({
					claimStatus: "unclaimed",
					claimError: e
				}), p({
					type: "claim_error",
					error: e
				});
				return;
			}
			n === d && (m({
				claimStatus: "claimed",
				pendingClaim: null,
				claim: r
			}), p({
				type: "claimed",
				claim: r
			}));
		},
		sellBack: async () => {
			if (f || !e.sellBackReveal || c.phase !== "results" || c.claimStatus !== "unclaimed") return;
			let t = c.pendingClaim;
			if (!t) return;
			let n = d;
			m({
				claimStatus: "selling",
				claimError: null,
				sellError: null
			}), p({
				type: "sell_back_start",
				openGroupId: t.openGroupId
			});
			let r;
			try {
				r = await e.sellBackReveal(t);
			} catch (e) {
				if (n !== d) return;
				m({
					claimStatus: "unclaimed",
					sellError: e
				}), p({
					type: "sell_back_error",
					error: e
				});
				return;
			}
			n === d && (m({
				claimStatus: "sold",
				pendingClaim: null,
				claim: r,
				sale: r
			}), p({
				type: "sold_back",
				sale: r
			}));
		},
		restore: (e) => {
			f || c.phase !== "idle" || c.pendingClaim || (m({
				phase: "results",
				entries: e.entries,
				claimStatus: "unclaimed",
				pendingClaim: {
					openGroupId: e.openGroupId,
					costCents: e.costCents
				},
				claim: null,
				claimError: null,
				sale: null,
				sellError: null,
				error: null
			}), p({
				type: "restored",
				reveal: e
			}));
		},
		reset: () => {
			c.claimStatus !== "unclaimed" && c.claimStatus !== "claiming" && c.claimStatus !== "selling" && (d++, h(), (c.phase !== "idle" || c.error !== null || c.entries.length !== 0) && (m({
				phase: "idle",
				entries: [],
				claimStatus: "none",
				pendingClaim: null,
				claim: null,
				claimError: null,
				sale: null,
				sellError: null,
				error: null
			}), p({ type: "reset" })));
		},
		setQuantity: (e) => {
			let t = s(e);
			t !== c.quantity && (c.phase === "idle" || c.phase === "results") && m({ quantity: t });
		},
		setQuickReveal: (e) => {
			e !== c.isQuickReveal && m({ isQuickReveal: e });
		},
		dispose: () => {
			f = !0, d++, h(), l.clear();
		},
		isDisposed: () => f
	};
}
//#endregion
//#region src/core/revealExit.ts
function Vn({ revealExit: e, isQuickReveal: t, actions: n }) {
	let r = null, i = () => {
		r &&= (clearTimeout(r), null);
	};
	return {
		completeReveal: () => {
			i();
			let a = t ? e.lingerMs.quick : e.lingerMs.normal;
			if (a === 0) {
				n.finishReveal();
				return;
			}
			r = setTimeout(() => {
				r = null, n.finishReveal();
			}, a);
		},
		skipReveal: (e) => {
			e?.(), i(), n.skipReveal();
		},
		cancel: i
	};
}
//#endregion
//#region src/core/types.ts
function Hn(e) {
	return e.demo === !0;
}
function Un(e) {
	if (typeof e != "object" || !e) return !1;
	let t = e;
	return typeof t.code == "string" && typeof t.message == "string";
}
//#endregion
//#region src/react/lootQueryClient.ts
var Wn;
function Gn() {
	return Wn ??= new re({ defaultOptions: {
		queries: {
			retry: !1,
			refetchOnWindowFocus: !1,
			refetchOnReconnect: !1,
			staleTime: 3e4
		},
		mutations: { retry: !1 }
	} }), Wn;
}
var Kn = /* @__PURE__ */ new WeakMap(), qn = 0;
function Jn(e) {
	if (!e) return null;
	let t = Kn.get(e);
	return t === void 0 && (qn += 1, t = qn, Kn.set(e, t)), t;
}
function Yn() {
	return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36);
}
var X = {
	panel: "_panel_1nqtp_1",
	toggle: "_toggle_1nqtp_11",
	chevron: "_chevron_1nqtp_30",
	chevronOpen: "_chevronOpen_1nqtp_35",
	body: "_body_1nqtp_39",
	row: "_row_1nqtp_46",
	label: "_label_1nqtp_52",
	value: "_value_1nqtp_57",
	seedInput: "_seedInput_1nqtp_63",
	entries: "_entries_1nqtp_78",
	entryRow: "_entryRow_1nqtp_87",
	muted: "_muted_1nqtp_94"
}, Xn = "los:clientSeed", Zn = 36;
function Qn() {
	return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID().split("-")[0] ?? "seed" : Math.random().toString(36).slice(2, 10);
}
function $n(e) {
	return e.slice(0, 36);
}
function er() {
	if (typeof window > "u") return null;
	try {
		let e = window.localStorage.getItem(Xn);
		return e ? $n(e) : null;
	} catch {
		return null;
	}
}
function tr({ clientSeed: e, onClientSeedChange: t }) {
	let n = e !== void 0, [r, i] = R(() => er() ?? Qn());
	N(() => {
		if (!(n || typeof window > "u")) try {
			window.localStorage.setItem(Xn, r);
		} catch {}
	}, [n, r]);
	let a = j((e) => {
		let r = $n(e);
		t?.(r), n || i(r);
	}, [n, t]);
	return [n ? $n(e) : r, a];
}
//#endregion
//#region src/fairness/ProvablyFairPanel.tsx
function nr() {
	return (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
}
function rr({ client: e, lastResponse: t, clientSeed: n, onClientSeedChange: r, locked: i = !1, defaultOpen: o = !1, className: s }) {
	let { strings: c } = a(), [l, u] = R(o), d = P(), f = t?.fairness ?? null, p = ie({
		queryKey: [
			"loot-os",
			"seed",
			Jn(e),
			nr()
		],
		queryFn: async () => await e?.getSeed?.(nr()) ?? null,
		enabled: l && !f && !!e?.getSeed,
		staleTime: Infinity
	}, Gn()), m = f?.serverSeedHash ?? p.data?.seedHash ?? null;
	return /* @__PURE__ */ H("div", {
		className: q(X.panel, s),
		children: [/* @__PURE__ */ H("button", {
			type: "button",
			className: X.toggle,
			"aria-expanded": l,
			"aria-controls": d,
			onClick: () => u((e) => !e),
			children: [
				/* @__PURE__ */ V("span", {
					"aria-hidden": !0,
					children: "ⓘ"
				}),
				c.provablyFair,
				/* @__PURE__ */ V("span", {
					"aria-hidden": !0,
					className: q(X.chevron, l && X.chevronOpen),
					children: "▾"
				})
			]
		}), l && /* @__PURE__ */ H("div", {
			className: X.body,
			id: d,
			children: [
				/* @__PURE__ */ H("div", {
					className: X.row,
					children: [/* @__PURE__ */ V("span", {
						className: X.label,
						children: c.serverSeedHash
					}), /* @__PURE__ */ V("span", {
						className: X.value,
						children: m ?? "…"
					})]
				}),
				/* @__PURE__ */ H("div", {
					className: X.row,
					children: [/* @__PURE__ */ V("label", {
						className: X.label,
						htmlFor: `${d}-seed`,
						children: c.clientSeed
					}), /* @__PURE__ */ V("input", {
						id: `${d}-seed`,
						className: X.seedInput,
						value: n,
						maxLength: 36,
						disabled: i,
						onChange: (e) => r(e.target.value)
					})]
				}),
				f ? /* @__PURE__ */ H(B, { children: [
					/* @__PURE__ */ H("div", {
						className: X.row,
						children: [/* @__PURE__ */ V("span", {
							className: X.label,
							children: c.salt
						}), /* @__PURE__ */ V("span", {
							className: X.value,
							children: f.salt
						})]
					}),
					/* @__PURE__ */ H("div", {
						className: X.row,
						children: [/* @__PURE__ */ V("span", {
							className: X.label,
							children: c.seedDate
						}), /* @__PURE__ */ V("span", {
							className: X.value,
							children: f.seedDate
						})]
					}),
					/* @__PURE__ */ H("div", {
						className: X.row,
						children: [/* @__PURE__ */ H("span", {
							className: X.label,
							children: [
								c.nonce,
								" / ",
								c.result
							]
						}), /* @__PURE__ */ V("ul", {
							className: X.entries,
							children: (t?.entries ?? []).map((e) => /* @__PURE__ */ H("li", {
								className: X.entryRow,
								children: [/* @__PURE__ */ H("span", { children: ["#", e.nonce] }), /* @__PURE__ */ V("span", { children: e.result })]
							}, e.openId))
						})]
					})
				] }) : /* @__PURE__ */ V("span", {
					className: X.muted,
					children: c.noOpensYet
				})
			]
		})]
	});
}
//#endregion
//#region src/demo/demoOpen.ts
function ir() {
	if (typeof crypto < "u" && typeof crypto.getRandomValues == "function") {
		let e = /* @__PURE__ */ new Uint32Array(1), t = Math.floor(4294967296 / g) * g, n = 0;
		do
			crypto.getRandomValues(e), n = e[0] ?? 0;
		while (n >= t);
		return n % g;
	}
	return Math.floor(Math.random() * g);
}
function ar(e) {
	return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? `${e}_${crypto.randomUUID()}` : `${e}_${Math.random().toString(36).slice(2)}`;
}
function or(e, t, n) {
	let r = [];
	for (let n = 0; n < t; n++) {
		let t = ir(), i = m(e.dropTable, t) ?? 0, a = e.dropTable[i];
		a && r.push({
			openId: ar("demo_open"),
			nonce: n,
			result: t,
			itemIndex: i,
			item: a
		});
	}
	return {
		demo: !0,
		openGroupId: ar("demo_group"),
		boxId: e.id,
		boxVersion: e.version,
		costCents: e.priceCents * t,
		dropTableHash: e.dropTableHash,
		status: "unclaimed",
		claim: null,
		entries: r,
		fairness: {
			seedDate: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10),
			serverSeedHash: "demo",
			clientSeed: n,
			salt: "demo",
			nonces: r.map((e) => e.nonce)
		}
	};
}
function sr(e, t) {
	return {
		openGroupId: e.openGroupId,
		costCents: e.costCents,
		balanceAfterCents: 0,
		claimedAt: (/* @__PURE__ */ new Date()).toISOString(),
		items: t.map((e) => ({
			openId: e.openId,
			inventoryItemId: ar("demo_inv"),
			item: e.item,
			isLimited: e.item.isLimited ?? !1
		}))
	};
}
function cr(e, t) {
	let n = sr(e, t), r = t.reduce((e, t) => e + t.item.value, 0);
	return {
		...n,
		balanceAfterCents: n.balanceAfterCents + r,
		soldCents: r,
		soldAt: (/* @__PURE__ */ new Date()).toISOString()
	};
}
var Z = {
	opener: "_opener_pm16a_3",
	band: "_band_pm16a_11",
	bandDesktop: "_bandDesktop_pm16a_24",
	bandMobile: "_bandMobile_pm16a_28",
	stage: "_stage_pm16a_35",
	brandMark: "_brandMark_pm16a_46",
	brandName: "_brandName_pm16a_58",
	railLayer: "_railLayer_pm16a_78",
	wheelArea: "_wheelArea_pm16a_88",
	spinner: "_spinner_pm16a_102",
	spinnerRow: "_spinnerRow_pm16a_113",
	spinnerColumn: "_spinnerColumn_pm16a_118",
	laneRow2: "_laneRow2_pm16a_123",
	laneRowHorizontal: "_laneRowHorizontal_pm16a_130",
	laneRowVertical: "_laneRowVertical_pm16a_134",
	lane: "_lane_pm16a_123",
	laneHorizontal: "_laneHorizontal_pm16a_143",
	laneVertical: "_laneVertical_pm16a_147",
	laneItems: "_laneItems_pm16a_151",
	laneItemsHorizontal: "_laneItemsHorizontal_pm16a_157",
	laneItemsVertical: "_laneItemsVertical_pm16a_161",
	card: "_card_pm16a_166",
	cardImage: "_cardImage_pm16a_174",
	itemLabel: "_itemLabel_pm16a_182",
	itemLabelHidden: "_itemLabelHidden_pm16a_192",
	itemLabelInner: "_itemLabelInner_pm16a_196",
	itemLabelValue: "_itemLabelValue_pm16a_204",
	itemLabelName: "_itemLabelName_pm16a_210",
	fade: "_fade_pm16a_223",
	fadeLeft: "_fadeLeft_pm16a_230",
	fadeRight: "_fadeRight_pm16a_238",
	fadeTop: "_fadeTop_pm16a_246",
	fadeBottom: "_fadeBottom_pm16a_254",
	railRoot: "_railRoot_pm16a_263",
	railSvg: "_railSvg_pm16a_270",
	railTop: "_railTop_pm16a_274",
	railBottom: "_railBottom_pm16a_280",
	railLeft: "_railLeft_pm16a_286",
	railRight: "_railRight_pm16a_292"
};
//#endregion
//#region src/spinner/SpinnerWheel.tsx
function lr({ item: t }) {
	let { currency: n } = a();
	return /* @__PURE__ */ H("div", {
		className: Z.itemLabelInner,
		children: [/* @__PURE__ */ V("span", {
			className: Z.itemLabelValue,
			children: e(t.value, n, { compact: !0 })
		}), /* @__PURE__ */ V("p", {
			className: Z.itemLabelName,
			children: t.name
		})]
	});
}
function ur({ index: e, getBoxItemsByIndex: t, animationPhase: n, setAnimationPhase: r, isRowOpen: i, geometry: a, timing: o, sounds: s, selectedOpenQuantity: c, isMobile: u, rarityRgb: d, selectedItemIndexRef: p, onRevealComplete: m, onItemSettled: h, renderItemLabel: g }) {
	let { itemWidth: _, gap: v, containerWidth: y, containerHeight: b, startingOffset: x, endingOffset: S, spinSnapOffsets: C } = a, { animationDuration: w, spinStartDelaySec: T, staggerDelay: E, popupDuration: D } = o, { playTickSound: O, playRaritySound: k, lastTickTimeRef: A } = s, j = t(e), M = () => {
		let t = j?.[35];
		t && (h?.(t.rarity, e), k(t.rarity));
	}, N = w + e * E, P = !u;
	return /* @__PURE__ */ V(U.div, {
		className: q(Z.lane, i ? Z.laneHorizontal : Z.laneVertical),
		"data-los-lane": e,
		initial: {
			transform: i ? `translateX(${x}px)` : `translateY(${x}px)`,
			opacity: 0
		},
		animate: n === "initialSpin" ? {
			transform: i ? `translateX(${S + (C[e] ?? 0)}px)` : `translateY(${S + (C[e] ?? 0)}px)`,
			opacity: 1
		} : {
			transform: i ? `translateX(${S}px)` : `translateY(${S}px)`,
			opacity: 1
		},
		transition: n === "initialSpin" ? {
			type: "tween",
			duration: w,
			delay: T,
			ease: [
				.25,
				.8,
				.5,
				1
			],
			opacity: {
				duration: .3,
				ease: "easeOut",
				delay: T
			}
		} : {
			type: "tween",
			duration: 300 / 1e3,
			ease: "easeOut",
			delay: e * E
		},
		style: { willChange: "transform, opacity" },
		onUpdate: (t) => {
			if (n !== "initialSpin" || !j || e !== 0) return;
			let r = Date.now();
			if (r - A.current < 16) return;
			A.current = r;
			let i = (t.transform ?? "").match(/translate[XY]\((-?\d+\.?\d*)px\)/);
			if (!i?.[1]) return;
			let a = Number.parseFloat(i[1]), o = u ? y / 2 : (c === 1 ? y : b) / 2, s = Math.round((o - a - _ / 2) / (_ + v));
			p.current !== s && s >= 0 && s < j.length && (p.current = s, O());
		},
		onAnimationComplete: () => {
			n === "initialSpin" ? r("snap") : n === "snap" && M();
		},
		children: /* @__PURE__ */ V("div", {
			className: q(Z.laneItems, i ? Z.laneItemsHorizontal : Z.laneItemsVertical),
			style: { gap: `${v}px` },
			children: j?.map((t, n) => /* @__PURE__ */ H(U.div, {
				className: Z.card,
				style: {
					height: `${_}px`,
					width: `${_}px`,
					willChange: n === 35 ? "transform" : "transform, opacity"
				},
				animate: n === 35 ? { scale: [
					1,
					1.12,
					1.08
				] } : {
					scale: [1, .9],
					opacity: [1, .25]
				},
				transition: {
					type: "tween",
					duration: D,
					ease: "easeOut",
					delay: N
				},
				onAnimationComplete: () => {
					!P && n === 35 && e === c - 1 && m?.();
				},
				children: [/* @__PURE__ */ V(U.img, {
					src: t.imageUrl ?? "",
					alt: `${t.name}`,
					loading: "eager",
					decoding: "async",
					width: _,
					height: _,
					sizes: `${_}px`,
					className: Z.cardImage,
					style: {
						borderRadius: _ < 90 ? "4px" : "8px",
						zIndex: 1,
						willChange: n === 35 ? "filter" : "auto"
					},
					initial: n === 35 ? { filter: f(d, t.rarity, "0px", "0") } : void 0,
					animate: n === 35 ? { filter: l(d, t.rarity) } : void 0,
					transition: n === 35 ? {
						duration: 300 / 1e3,
						ease: "easeOut",
						delay: N
					} : void 0
				}), P && /* @__PURE__ */ V(U.div, {
					className: q(Z.itemLabel, n !== 35 && Z.itemLabelHidden),
					initial: c > 1 ? {
						opacity: 0,
						y: -50
					} : void 0,
					animate: n === 35 ? {
						y: [-50, 0],
						opacity: [0, 1]
					} : {},
					transition: {
						type: "keyframes",
						duration: D,
						delay: N
					},
					onAnimationComplete: () => {
						e === c - 1 && n === 35 && m && m();
					},
					children: g ? g(t) : /* @__PURE__ */ V(lr, { item: t })
				})]
			}, `spinner-${e}-item-${n}-${t.itemId ?? t.name}`))
		})
	});
}
//#endregion
//#region src/spinner/useSpinnerWheelItems.ts
function dr({ box: e, revealedItems: t, prandGenerator: n, itemWidth: r, gap: i, containerWidth: a, containerHeight: o, selectedOpenQuantity: s, isMobile: c }) {
	let l = I(() => t.slice(0, s).map((t) => Et(e, 35, t, n)), [
		e,
		n,
		t,
		s
	]), u = (e) => l[e] ?? null, d = (e) => {
		switch (e) {
			case 2: return c ? { gap: 56 } : {
				marginLeft: "22%",
				marginRight: "22%"
			};
			case 3: return c ? { gap: 32 } : {
				marginLeft: "15%",
				marginRight: "15%"
			};
			case 4: return c ? { gap: 24 } : {
				marginLeft: "10%",
				marginRight: "10%"
			};
			case 5: return c ? { gap: 20 } : {
				marginLeft: "5%",
				marginRight: "5%"
			};
			default: return {};
		}
	}, f = I(() => {
		let e = [];
		for (let t = 0; t < s; t++) {
			let n = Math.floor(Math.random() * 2) === 0;
			e[t] = r / 4 * Math.random() * (n ? -1 : 1) + r / 4 * (n ? -1 : 1);
		}
		return e;
	}, [r, s]), { startingOffset: p, endingOffset: m } = I(() => {
		let e = c ? a / 2 : (s === 1 ? a : o) / 2, t = r * 4 + i * 3 - r / 2, n = r * 36 + i * 35 - r / 2;
		return {
			startingOffset: e - t,
			endingOffset: e - n
		};
	}, [
		s,
		a,
		o,
		r,
		i,
		c
	]);
	return {
		getBoxItemsByIndex: u,
		getMultiOpenSpacing: d,
		spinSnapOffsets: f,
		startingOffset: p,
		endingOffset: m
	};
}
//#endregion
//#region src/spinner/MotionSpinner.tsx
function fr({ className: e, gap: t = 0, box: n, isQuickReveal: r = !1, revealedItems: i, prandGenerator: a, itemWidth: o, containerWidth: s, containerHeight: c, selectedOpenQuantity: l, isMobile: u, sounds: d, rarityRgb: f, onRevealComplete: p, onItemSettled: m, renderItemLabel: h }) {
	let [g, _] = R("initialSpin"), v = l === 1 || u, y = L(null), b = L(0), x = I(() => r ? yt / 1e3 : vt / 1e3, [r]), S = I(() => r ? 150 / 1e3 : 250 / 1e3, [r]), { getBoxItemsByIndex: C, getMultiOpenSpacing: w, spinSnapOffsets: T, startingOffset: E, endingOffset: D } = dr({
		box: n,
		revealedItems: i,
		prandGenerator: a,
		itemWidth: o,
		gap: t,
		containerWidth: s,
		containerHeight: c,
		selectedOpenQuantity: l,
		isMobile: u
	}), O = I(() => ({
		itemWidth: o,
		gap: t,
		containerWidth: s,
		containerHeight: c,
		startingOffset: E,
		endingOffset: D,
		spinSnapOffsets: T
	}), [
		o,
		t,
		s,
		c,
		E,
		D,
		T
	]), k = I(() => ({
		animationDuration: x,
		spinStartDelaySec: .25,
		staggerDelay: S,
		popupDuration: 1
	}), [x, S]), A = I(() => ({
		playTickSound: d.playTickSound,
		playRaritySound: d.playRaritySound,
		lastTickTimeRef: b
	}), [d.playTickSound, d.playRaritySound]);
	return /* @__PURE__ */ H("div", {
		className: q(Z.spinner, v ? Z.spinnerRow : Z.spinnerColumn, e),
		children: [C(0) && /* @__PURE__ */ V("div", {
			className: q(Z.laneRow2, u ? Z.laneRowHorizontal : Z.laneRowVertical),
			style: w(l),
			children: Array.from({ length: l }, (e, t) => /* @__PURE__ */ V(ur, {
				index: t,
				getBoxItemsByIndex: C,
				animationPhase: g,
				setAnimationPhase: _,
				isRowOpen: v,
				geometry: O,
				timing: k,
				sounds: A,
				selectedOpenQuantity: l,
				isMobile: u,
				rarityRgb: f,
				selectedItemIndexRef: y,
				onRevealComplete: p,
				onItemSettled: m,
				renderItemLabel: h
			}, `spinner-${t}`))
		}), v ? /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ V("div", { className: q(Z.fade, Z.fadeLeft) }), /* @__PURE__ */ V("div", { className: q(Z.fade, Z.fadeRight) })] }) : /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ V("div", { className: q(Z.fade, Z.fadeTop) }), /* @__PURE__ */ V("div", { className: q(Z.fade, Z.fadeBottom) })] })]
	});
}
//#endregion
//#region src/spinner/SpinnerPointerRail.tsx
function pr({ orientation: e, color: t, inset: n = 10, className: r }) {
	return e === "vertical" ? /* @__PURE__ */ H("div", {
		"aria-hidden": !0,
		className: q(Z.railRoot, r),
		children: [/* @__PURE__ */ V(hr, {
			className: q(Z.railSvg, Z.railLeft),
			color: t,
			style: { left: n }
		}), /* @__PURE__ */ V(hr, {
			className: q(Z.railSvg, Z.railRight),
			color: t,
			style: { right: n }
		})]
	}) : /* @__PURE__ */ H("div", {
		"aria-hidden": !0,
		className: q(Z.railRoot, r),
		children: [/* @__PURE__ */ V(mr, {
			className: q(Z.railSvg, Z.railTop),
			color: t,
			style: { top: n }
		}), /* @__PURE__ */ V(mr, {
			className: q(Z.railSvg, Z.railBottom),
			color: t,
			style: { bottom: n }
		})]
	});
}
function mr({ className: e, color: t, style: n }) {
	let r = gr();
	return /* @__PURE__ */ H("svg", {
		"aria-hidden": "true",
		className: e,
		width: "74",
		height: "14",
		viewBox: "0 0 74 14",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ V("path", {
			d: "M0.00390625 13.3119L30.6914 13.5L36.6914 1.49988L42.7655 13.498M73.5039 13.3124L58.5039 13.3119L42.7655 13.498L36.6914 4.49988L30.6914 13.498",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ V("defs", { children: /* @__PURE__ */ H("linearGradient", {
			id: r,
			x1: "74",
			y1: "7",
			x2: "0",
			y2: "7",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ V("stop", {
					stopColor: t,
					stopOpacity: "0"
				}),
				/* @__PURE__ */ V("stop", {
					offset: "0.5",
					stopColor: t
				}),
				/* @__PURE__ */ V("stop", {
					offset: "1",
					stopColor: t,
					stopOpacity: "0"
				})
			]
		}) })]
	});
}
function hr({ className: e, color: t, style: n }) {
	let r = gr();
	return /* @__PURE__ */ H("svg", {
		"aria-hidden": "true",
		className: e,
		width: "14",
		height: "74",
		viewBox: "0 0 14 74",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ V("path", {
			d: "M0.688111 0.00390625L0.5 30.6914L12.5001 36.6914L0.501953 42.7655M0.687616 73.5039L0.688111 58.5039L0.501953 42.7655L9.50012 36.6914L0.501953 30.6914",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ V("defs", { children: /* @__PURE__ */ H("linearGradient", {
			id: r,
			x1: "7",
			y1: "0",
			x2: "7",
			y2: "74",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ V("stop", {
					stopColor: t,
					stopOpacity: "0"
				}),
				/* @__PURE__ */ V("stop", {
					offset: "0.5",
					stopColor: t
				}),
				/* @__PURE__ */ V("stop", {
					offset: "1",
					stopColor: t,
					stopOpacity: "0"
				})
			]
		}) })]
	});
}
function gr() {
	return `los-spinner-rail-${P().replace(/:/g, "")}`;
}
//#endregion
//#region src/spinner/SpinnerOpener.tsx
var _r = 768;
function vr(e) {
	switch (e) {
		case 1: return 220;
		case 2: return 160;
		case 3: return 115;
		case 4: return 80;
		case 5: return 72;
		default: return 150;
	}
}
function yr(e) {
	switch (e) {
		case 1: return 32;
		case 2: return 24;
		case 3: return 16;
		case 4: return 12;
		case 5: return 6;
		default: return 32;
	}
}
function br({ boxData: e, entries: t, quantity: i, isQuickReveal: o, prandGenerator: s, onRevealComplete: l }) {
	let { theme: u, sounds: d, renderItemLabel: f } = a(), p = L(null), m = L(null), [h, g] = R(null), [_, v] = R(0), [y, b] = R(0);
	F(() => {
		let e = p.current;
		if (!e) return;
		let t = () => g(e.offsetWidth);
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, []);
	let x = h === null ? null : h < _r;
	F(() => {
		let e = m.current;
		if (!e) return;
		let t = () => {
			v(e.offsetWidth), b(e.offsetHeight);
		};
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, [x]);
	let S = I(() => t.map((e) => e.item), [t]), C = I(() => t.length ? Math.max(...t.map((t) => r(t.item.value, e.priceCents ?? 0))) : null, [t, e.priceCents]), [w, T] = R(!1);
	N(() => {
		T(!1);
	}, [t]);
	let E = j((e) => {
		C !== null && e >= C && T(!0);
	}, [C]), D = w && C !== null ? c(u.railHex, C) : c(u.railHex, null), O = I(() => ({
		priceCents: e.priceCents,
		dropTable: e.dropTable
	}), [e.priceCents, e.dropTable]), k = e.opener?.logoSvg, A = e.opener?.brandName?.trim(), M = I(() => k ? /* @__PURE__ */ V("img", {
		className: Z.brandMark,
		src: n(k),
		alt: "",
		"aria-hidden": "true"
	}) : A ? /* @__PURE__ */ V("span", {
		className: Z.brandName,
		"aria-hidden": "true",
		children: A
	}) : null, [k, A]);
	return /* @__PURE__ */ V("div", {
		className: Z.opener,
		ref: p,
		children: x === null ? null : x ? /* @__PURE__ */ V("div", {
			className: q(Z.band, Z.bandMobile),
			children: /* @__PURE__ */ H("div", {
				className: Z.stage,
				children: [
					M,
					/* @__PURE__ */ V("div", {
						className: Z.railLayer,
						children: /* @__PURE__ */ V(pr, {
							orientation: "horizontal",
							color: D,
							inset: -4
						})
					}),
					/* @__PURE__ */ V("div", {
						className: Z.wheelArea,
						ref: m,
						children: /* @__PURE__ */ V(fr, {
							gap: yr(i),
							box: O,
							revealedItems: S,
							isQuickReveal: o,
							prandGenerator: s,
							itemWidth: vr(i),
							containerWidth: _,
							containerHeight: y,
							selectedOpenQuantity: i,
							isMobile: !0,
							sounds: d,
							rarityRgb: u.rarityRgb,
							onRevealComplete: l,
							onItemSettled: E,
							renderItemLabel: f
						})
					})
				]
			})
		}) : /* @__PURE__ */ V("div", {
			className: q(Z.band, Z.bandDesktop),
			children: /* @__PURE__ */ H("div", {
				className: Z.stage,
				children: [
					M,
					/* @__PURE__ */ V("div", {
						className: Z.railLayer,
						children: /* @__PURE__ */ V(pr, {
							orientation: i === 1 ? "horizontal" : "vertical",
							color: D
						})
					}),
					/* @__PURE__ */ V("div", {
						className: Z.wheelArea,
						ref: m,
						children: /* @__PURE__ */ V(fr, {
							gap: i > 1 ? 56 : 32,
							box: O,
							revealedItems: S,
							isQuickReveal: o,
							prandGenerator: s,
							itemWidth: 190,
							containerWidth: _,
							containerHeight: y,
							selectedOpenQuantity: i,
							isMobile: !1,
							sounds: d,
							rarityRgb: u.rarityRgb,
							onRevealComplete: l,
							onItemSettled: E,
							renderItemLabel: f
						})
					})
				]
			})
		})
	});
}
//#endregion
//#region src/openers/SpinnerRevealOpener.tsx
function xr({ boxData: e, reveal: t, onRevealComplete: n }) {
	return /* @__PURE__ */ V(br, {
		boxData: e,
		entries: t.entries,
		quantity: t.quantity,
		isQuickReveal: t.isQuickReveal,
		prandGenerator: t.prandGenerator,
		onRevealComplete: n
	});
}
//#endregion
//#region src/openers/registry.ts
var Sr = { spinner: T({
	Opener: xr,
	loopTarget: "loop",
	supportsBulk: !0,
	revealExit: { lingerMs: wt }
}) }, Cr = "spinner";
function wr(e) {
	if (e) {
		let t = E(e) ?? (Object.hasOwn(Sr, e) ? Sr[e] : void 0);
		if (t) return t;
	}
	return Sr[Cr];
}
//#endregion
//#region src/react/hooks.ts
function Tr({ client: e, boxId: t }) {
	let n = ie({
		queryKey: [
			"loot-os",
			"box",
			Jn(e),
			t
		],
		queryFn: () => {
			if (!e) throw Error("[loot-os] no API client configured");
			return e.getBox(t);
		},
		enabled: !!e
	}, Gn()), { refetch: r } = n, i = j(() => void r(), [r]);
	return {
		box: n.data ?? null,
		loading: !!e && n.isFetching,
		error: n.isFetching ? null : n.error ?? null,
		reload: i
	};
}
function Er({ client: e, boxId: t, clientSeed: n, expectedVersion: r }) {
	let i = G({
		mutationKey: [
			"loot-os",
			"open",
			Jn(e),
			t
		],
		mutationFn: (i) => {
			if (!e) throw Error("[loot-os] no API client configured");
			return e.openBox({
				boxId: t,
				clientSeed: n,
				amount: i.quantity,
				expectedVersion: r,
				idempotencyKey: i.idempotencyKey
			});
		}
	}, Gn()), { mutateAsync: a } = i;
	return {
		open: j(async (t = 1) => {
			if (!e) return null;
			try {
				return await a({
					quantity: t,
					idempotencyKey: Yn()
				});
			} catch {
				return null;
			}
		}, [e, a]),
		opening: i.isPending,
		response: i.data ?? null,
		error: i.error ?? null
	};
}
//#endregion
//#region src/react/useOpenerMachine.ts
function Dr(e) {
	return z(e.subscribe, e.getState, e.getState);
}
function Or(e) {
	let t = L(e);
	t.current = e;
	let n = L(null);
	n.current === null && (n.current = () => Bn({
		openBox: (e) => t.current.openBox(e),
		claimReveal: e.claimReveal ? (e) => {
			let n = t.current.claimReveal;
			if (!n) throw Error("[loot-os] claimReveal config removed mid-flight");
			return n(e);
		} : void 0,
		sellBackReveal: e.sellBackReveal ? (e) => {
			let n = t.current.sellBackReveal;
			if (!n) throw Error("[loot-os] sellBackReveal config removed mid-flight");
			return n(e);
		} : void 0,
		onBeforeOpen: (e) => t.current.onBeforeOpen?.(e),
		onEvent: (e) => t.current.onEvent?.(e),
		revealStartDelayMs: e.revealStartDelayMs,
		minQuantity: e.minQuantity,
		maxQuantity: e.maxQuantity,
		defaultQuantity: e.defaultQuantity,
		defaultQuickReveal: e.defaultQuickReveal
	}));
	let r = n.current, [i, a] = R(r);
	return N(() => {
		if (i.isDisposed()) {
			a(r());
			return;
		}
		return () => i.dispose();
	}, [i, r]), {
		machine: i,
		state: Dr(i)
	};
}
//#endregion
//#region src/react/useResolvedClient.ts
var kr = async (e) => {
	let { LootClient: t } = await import("@loot-os/client");
	return new t(e);
};
function Ar({ client: e, createClient: t, publishableKey: n, baseUrl: r, sessionToken: i, onSessionExpired: a }) {
	let [o, s] = R(null), [c, l] = R(null), u = L(a);
	u.current = a, N(() => {
		if (e || !n) return;
		let i = !1, a = t ?? kr;
		return Promise.resolve(a({
			publishableKey: n,
			baseUrl: r,
			sessionToken: null,
			onSessionExpired: () => u.current ? u.current() : Promise.resolve(null)
		})).then((e) => {
			i || s(e);
		}).catch((e) => {
			i || l(e);
		}), () => {
			i = !0;
		};
	}, [
		e,
		t,
		n,
		r
	]);
	let d = e ?? o;
	return N(() => {
		d?.setSessionToken?.(i ?? null);
	}, [d, i]), {
		client: d,
		error: c
	};
}
var jr = {
	scroller: "_scroller_ujyfz_3",
	track: "_track_ujyfz_13",
	trackAnimated: "_trackAnimated_ujyfz_19",
	losIdleCardScroll: "_losIdleCardScroll_ujyfz_1",
	loop: "_loop_ujyfz_24",
	slot: "_slot_ujyfz_31",
	floatY: "_floatY_ujyfz_37",
	losFloatY: "_losFloatY_ujyfz_1",
	floatYDelay1: "_floatYDelay1_ujyfz_41",
	floatYSmall: "_floatYSmall_ujyfz_45",
	losFloatYSmall: "_losFloatYSmall_ujyfz_1",
	floatYSmallDelay1: "_floatYSmallDelay1_ujyfz_49",
	fadeLeft: "_fadeLeft_ujyfz_53",
	fadeRight: "_fadeRight_ujyfz_70"
}, Mr = 12;
function Nr(e, t) {
	let n = e % 2 == 1;
	return t ? n ? jr.floatYSmallDelay1 ?? "" : jr.floatYSmall ?? "" : n ? jr.floatYDelay1 ?? "" : jr.floatY ?? "";
}
function Pr({ slots: e, itemWidth: t, gap: n = 0, isMobile: r = !1, direction: i = "left", className: a }) {
	let o = I(() => {
		if (e.length === 0) return 0;
		let t = Math.max(2, Math.ceil(Mr / e.length));
		return t % 2 == 0 ? t : t + 1;
	}, [e.length]), s = e.length * (t + n), c = Math.max(1.5, e.length * (r ? 2.5 : 8));
	return /* @__PURE__ */ H("div", {
		"aria-hidden": !0,
		className: q(jr.scroller, a),
		children: [
			/* @__PURE__ */ V("div", {
				className: q(jr.track, e.length > 0 && jr.trackAnimated),
				style: {
					gap: `${n}px`,
					"--los-idle-scroll-distance": `-${s}px`,
					"--los-idle-scroll-duration": `${c}s`,
					animationDirection: i === "left" ? "normal" : "reverse"
				},
				children: Array.from({ length: o }, (i, a) => /* @__PURE__ */ V("div", {
					className: jr.loop,
					style: { gap: `${n}px` },
					children: e.map((e, n) => /* @__PURE__ */ V("div", {
						className: q(jr.slot, Nr(n, r)),
						style: {
							width: `${t}px`,
							height: `${t}px`
						},
						children: e
					}, `loop-${a}-${n}`))
				}, a))
			}),
			/* @__PURE__ */ V("div", { className: jr.fadeLeft }),
			/* @__PURE__ */ V("div", { className: jr.fadeRight })
		]
	});
}
var Fr = A(Pr), Q = {
	root: "_root_15znn_5",
	phase: "_phase_15znn_38",
	losPhaseFadeIn: "_losPhaseFadeIn_15znn_1",
	hostIdle: "_hostIdle_15znn_65",
	idleHero: "_idleHero_15znn_70",
	brandLogo: "_brandLogo_15znn_78",
	brandName: "_brandName_15znn_84",
	boxImage: "_boxImage_15znn_95",
	boxName: "_boxName_15znn_102",
	boxPrice: "_boxPrice_15znn_109",
	idleScrollerArea: "_idleScrollerArea_15znn_115",
	idleCard: "_idleCard_15znn_123",
	idleCardImage: "_idleCardImage_15znn_132",
	controls: "_controls_15znn_141",
	controlsRow: "_controlsRow_15znn_150",
	quantityGroup: "_quantityGroup_15znn_159",
	quantityButton: "_quantityButton_15znn_171",
	quantityButtonActive: "_quantityButtonActive_15znn_187",
	primaryButton: "_primaryButton_15znn_192",
	secondaryButton: "_secondaryButton_15znn_221",
	toggleLabel: "_toggleLabel_15znn_242",
	priceTag: "_priceTag_15znn_251",
	revealArea: "_revealArea_15znn_258",
	revealStage: "_revealStage_15znn_267",
	demoAnchor: "_demoAnchor_15znn_277",
	demoBadge: "_demoBadge_15znn_282",
	errorBanner: "_errorBanner_15znn_304",
	loading: "_loading_15znn_315",
	fairnessArea: "_fairnessArea_15znn_324",
	openerLoading: "_openerLoading_15znn_350",
	stageOwned: "_stageOwned_15znn_363"
};
//#endregion
//#region src/shell/DemoTag.tsx
function Ir({ demo: e, children: t }) {
	let { strings: n } = a();
	return e ? /* @__PURE__ */ H("span", {
		className: Q.demoAnchor,
		children: [t, /* @__PURE__ */ V("span", {
			className: Q.demoBadge,
			children: n.demoBadge
		})]
	}) : /* @__PURE__ */ V(B, { children: t });
}
var $ = {
	results: "_results_1ypk9_1",
	grid: "_grid_1ypk9_10",
	item: "_item_1ypk9_19",
	itemImage: "_itemImage_1ypk9_32",
	itemName: "_itemName_1ypk9_39",
	itemValue: "_itemValue_1ypk9_51",
	total: "_total_1ypk9_57",
	totalValue: "_totalValue_1ypk9_62",
	claimError: "_claimError_1ypk9_67",
	actions: "_actions_1ypk9_73",
	autoClaimLabel: "_autoClaimLabel_1ypk9_81",
	itemImageWrap: "_itemImageWrap_1ypk9_90",
	itemImageSubstitute: "_itemImageSubstitute_1ypk9_97",
	substituteBadge: "_substituteBadge_1ypk9_101",
	itemNotice: "_itemNotice_1ypk9_117",
	itemActions: "_itemActions_1ypk9_125",
	itemButton: "_itemButton_1ypk9_133",
	itemStatus: "_itemStatus_1ypk9_152"
};
//#endregion
//#region src/results/ResultsItemCard.tsx
function Lr({ entry: e, claimed: t, action: n, onWithdraw: r, buttonClassName: i }) {
	let { strings: o } = a();
	return n?.status === "withdrawn" ? /* @__PURE__ */ V("p", {
		className: $.itemStatus,
		children: o.withdrawRequested
	}) : !r || e.item.isGemSubstitute === !0 ? null : /* @__PURE__ */ V("button", {
		type: "button",
		className: i,
		onClick: () => r(t),
		children: o.withdrawItem
	});
}
function Rr({ entry: e, claimed: t, action: n, onWithdraw: r }) {
	let { strings: i } = a();
	return n?.status === "withdrawn" ? null : e.item.isGemSubstitute !== !0 && t.isLimited && r ? /* @__PURE__ */ V("p", {
		className: $.itemNotice,
		children: i.limitedItemNotice
	}) : null;
}
function zr(e) {
	let { strings: t } = a(), { entry: n, claimed: r, action: i, onWithdraw: o } = e;
	if (i?.status === "withdrawn") return /* @__PURE__ */ V(Lr, { ...e });
	let s = n.item.isGemSubstitute === !0;
	return !o || s ? null : /* @__PURE__ */ H(B, { children: [r.isLimited ? /* @__PURE__ */ V("p", {
		className: $.itemNotice,
		children: t.limitedItemNotice
	}) : null, /* @__PURE__ */ V("div", {
		className: $.itemActions,
		children: /* @__PURE__ */ V(Lr, {
			...e,
			buttonClassName: $.itemButton
		})
	})] });
}
function Br({ entry: t, claimed: n, action: r, onWithdraw: i }) {
	let { strings: o, currency: s } = a(), c = t.item.isGemSubstitute === !0;
	return /* @__PURE__ */ H("div", {
		className: $.item,
		children: [
			/* @__PURE__ */ H("div", {
				className: $.itemImageWrap,
				children: [/* @__PURE__ */ V("img", {
					className: q($.itemImage, c && $.itemImageSubstitute),
					src: t.item.imageUrl,
					alt: t.item.name,
					loading: "eager",
					decoding: "async"
				}), c ? /* @__PURE__ */ V("span", {
					className: $.substituteBadge,
					children: o.substituteBadge
				}) : null]
			}),
			/* @__PURE__ */ V("p", {
				className: $.itemName,
				children: t.item.name
			}),
			/* @__PURE__ */ V("span", {
				className: $.itemValue,
				children: e(t.item.value, s, { compact: !0 })
			}),
			n ? /* @__PURE__ */ V(zr, {
				entry: t,
				claimed: n,
				action: r,
				onWithdraw: i
			}) : null
		]
	});
}
//#endregion
//#region src/results/ResultsView.tsx
function Vr({ entries: t, claimStatus: n = "none", claimCostCents: r, claimErrorMessage: i, sellErrorMessage: o, onClaim: s, onSellBack: c, onAutoClaimChange: l, onOpenAgain: u, settledAction: d, claimedItems: f, itemActions: p, onWithdrawItem: m, buttonClassName: h, secondaryButtonClassName: g, showItems: _ = !0, demo: v = !1 }) {
	let { strings: y, currency: b } = a(), x = I(() => [...t].sort((e, t) => t.item.value - e.item.value), [t]), S = I(() => new Map((f ?? []).map((e) => [e.openId, e])), [f]), C = I(() => x.flatMap((e) => {
		let t = S.get(e.openId);
		return t ? [{
			entry: e,
			claimed: t,
			action: p?.[t.inventoryItemId]
		}] : [];
	}), [
		x,
		S,
		p
	]), w = I(() => t.reduce((e, t) => e + t.item.value, 0), [t]), T = n === "unclaimed" || n === "claiming" || n === "selling", E = n === "claiming" || n === "selling", D = !!c && w > 0, O = i ?? o ?? null;
	return /* @__PURE__ */ H("div", {
		className: $.results,
		children: [
			_ ? /* @__PURE__ */ V("div", {
				className: $.grid,
				children: x.map((e) => {
					let t = S.get(e.openId);
					return /* @__PURE__ */ V(Br, {
						entry: e,
						claimed: t,
						action: t ? p?.[t.inventoryItemId] : void 0,
						onWithdraw: m
					}, e.openId);
				})
			}) : null,
			t.length > 1 && /* @__PURE__ */ H("div", {
				className: $.total,
				children: [
					y.totalValue,
					":",
					" ",
					/* @__PURE__ */ V("span", {
						className: $.totalValue,
						children: e(w, b)
					})
				]
			}),
			O ? /* @__PURE__ */ V("div", {
				className: $.claimError,
				children: O
			}) : null,
			T ? /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ H("div", {
				className: $.actions,
				children: [/* @__PURE__ */ H("button", {
					type: "button",
					className: h,
					disabled: E,
					onClick: s,
					children: [n === "claiming" ? y.claiming : y.claim, r != null && n !== "claiming" ? /* @__PURE__ */ H(B, { children: [" ", e(r, b)] }) : null]
				}), D ? /* @__PURE__ */ H("button", {
					type: "button",
					className: g,
					disabled: E,
					onClick: c,
					children: [n === "selling" ? y.sellingBack : y.sellBack, n === "selling" ? null : /* @__PURE__ */ H(B, { children: [" ", e(w, b)] })]
				}) : null]
			}), l ? /* @__PURE__ */ H("label", {
				className: $.autoClaimLabel,
				children: [/* @__PURE__ */ V("input", {
					type: "checkbox",
					defaultChecked: !1,
					onChange: (e) => l(e.target.checked)
				}), y.autoClaimLabel]
			}) : null] }) : /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ H("div", {
				className: $.actions,
				children: [_ ? null : C.map(({ entry: e, claimed: t, action: n }) => /* @__PURE__ */ V(Lr, {
					entry: e,
					claimed: t,
					action: n,
					onWithdraw: m,
					buttonClassName: g
				}, e.openId)), /* @__PURE__ */ V(Ir, {
					demo: v,
					children: /* @__PURE__ */ V("button", {
						type: "button",
						className: h,
						onClick: d?.onClick ?? u,
						children: d?.label ?? y.openAgain
					})
				})]
			}), _ ? null : C.map(({ entry: e, claimed: t, action: n }) => /* @__PURE__ */ V(Rr, {
				entry: e,
				claimed: t,
				action: n,
				onWithdraw: m
			}, e.openId))] })
		]
	});
}
//#endregion
//#region src/shell/OpenerShell.tsx
var Hr = [
	1,
	2,
	3,
	4,
	5
], Ur = {
	canSkip: !0,
	custom: null
};
function Wr({ boxData: t, descriptor: i, loading: o, machine: s, state: c, exit: l, maxQuantity: u, quickRevealMode: d, isDemoMode: p, errorMessage: m, claimErrorMessage: h, sellErrorMessage: g, prandGenerator: _, onOpenClick: v, onAutoClaimChange: y, onSellBack: b, itemActions: x, onWithdrawItem: S, renderIdle: C, renderResults: T, settledAction: E, prepaid: D = !1, fairnessPanel: k, className: A, style: j }) {
	let { strings: M, theme: N, currency: P } = a(), F = w(c.phase), [z, ee] = R(Ur), U = I(() => t ? t.dropTable.filter((e) => e.weight > 0).map((e) => {
		let n = r(e.value, t.priceCents ?? 0);
		return /* @__PURE__ */ V("div", {
			className: Q.idleCard,
			children: /* @__PURE__ */ V("img", {
				className: Q.idleCardImage,
				style: { filter: f(N.rarityRgb, n, "10px", "0.4") },
				src: e.imageUrl,
				alt: e.name,
				loading: "lazy",
				decoding: "async"
			})
		}, e.itemId);
	}) : [], [t, N.rarityRgb]), te = c.phase === "requesting", ne = () => t ? /* @__PURE__ */ H("div", {
		className: Q.controls,
		children: [m ? /* @__PURE__ */ V("div", {
			className: Q.errorBanner,
			children: m
		}) : null, /* @__PURE__ */ H("div", {
			className: Q.controlsRow,
			children: [
				D || u <= 1 ? null : /* @__PURE__ */ V("fieldset", {
					className: Q.quantityGroup,
					"aria-label": M.quantity,
					children: Hr.filter((e) => e <= u).map((e) => /* @__PURE__ */ V("button", {
						type: "button",
						className: q(Q.quantityButton, e === c.quantity && Q.quantityButtonActive),
						"aria-pressed": e === c.quantity,
						disabled: te,
						onClick: () => s.setQuantity(e),
						children: e
					}, e))
				}),
				/* @__PURE__ */ V(Ir, {
					demo: p,
					children: /* @__PURE__ */ H("button", {
						type: "button",
						className: Q.primaryButton,
						disabled: te,
						onClick: v,
						children: [M.open, D ? null : /* @__PURE__ */ H(B, { children: ["\xA0", /* @__PURE__ */ V("span", {
							className: Q.priceTag,
							children: e(t.priceCents * c.quantity, P)
						})] })]
					})
				}),
				d === "toggle" ? /* @__PURE__ */ H("label", {
					className: Q.toggleLabel,
					children: [/* @__PURE__ */ V("input", {
						type: "checkbox",
						checked: c.isQuickReveal,
						onChange: (e) => s.setQuickReveal(e.target.checked)
					}), M.quickReveal]
				}) : null
			]
		})]
	}) : null, W = () => o || !t ? /* @__PURE__ */ V("div", {
		className: Q.loading,
		children: M.loading
	}) : C ? /* @__PURE__ */ V("div", {
		className: Q.hostIdle,
		children: C({
			boxData: t,
			open: v,
			quantity: c.quantity,
			setQuantity: s.setQuantity,
			quantities: D || u <= 1 ? [] : Hr.filter((e) => e <= u),
			quickReveal: d === "toggle" ? {
				on: c.isQuickReveal,
				set: s.setQuickReveal
			} : void 0,
			demo: p,
			requesting: te,
			errorMessage: m ?? null,
			prepaid: D
		})
	}) : /* @__PURE__ */ H(B, { children: [
		/* @__PURE__ */ H("div", {
			className: Q.idleHero,
			children: [
				t.opener?.logoSvg ? /* @__PURE__ */ V("img", {
					className: Q.brandLogo,
					src: n(t.opener.logoSvg),
					alt: "",
					"aria-hidden": "true"
				}) : t.opener?.brandName?.trim() ? /* @__PURE__ */ V("span", {
					className: Q.brandName,
					children: t.opener.brandName.trim()
				}) : null,
				t.imageUrl ? /* @__PURE__ */ V("img", {
					className: Q.boxImage,
					src: t.imageUrl,
					alt: t.name,
					loading: "eager",
					decoding: "async"
				}) : null,
				/* @__PURE__ */ V("h2", {
					className: Q.boxName,
					children: t.name
				}),
				D ? null : /* @__PURE__ */ V("span", {
					className: Q.boxPrice,
					children: e(t.priceCents, P)
				})
			]
		}),
		/* @__PURE__ */ V("div", {
			className: Q.idleScrollerArea,
			children: /* @__PURE__ */ V(Fr, {
				slots: U,
				itemWidth: 104,
				gap: 12
			})
		}),
		ne()
	] }), re = () => i.ActionRow ? /* @__PURE__ */ V(i.ActionRow, {
		controls: z,
		onSkip: () => l.skipReveal(z.onBeforeSkip)
	}) : z.canSkip ? /* @__PURE__ */ V("button", {
		type: "button",
		className: Q.secondaryButton,
		onClick: () => l.skipReveal(z.onBeforeSkip),
		children: M.skip
	}) : null, G = (e, t) => /* @__PURE__ */ V(O, {
		fallback: /* @__PURE__ */ V("div", {
			className: Q.openerLoading,
			children: M.loading
		}),
		children: /* @__PURE__ */ V(i.Opener, {
			boxData: e,
			reveal: {
				entries: t?.phase === "pre" ? [] : c.entries,
				quantity: Math.min(c.entries.length || c.quantity, u),
				isQuickReveal: c.isQuickReveal,
				prandGenerator: _
			},
			onRevealComplete: l.completeReveal,
			onControlsStateChange: ee,
			phase: t?.phase,
			controls: t?.controls
		}, t?.run)
	}), ie = () => t ? /* @__PURE__ */ H("div", {
		className: Q.revealArea,
		children: [/* @__PURE__ */ V("div", {
			className: Q.revealStage,
			children: G(t)
		}), re()]
	}) : null, K = () => s.reset(), ae = (e) => /* @__PURE__ */ V(Vr, {
		showItems: e,
		entries: c.entries,
		claimStatus: c.claimStatus,
		claimCostCents: D ? null : c.pendingClaim?.costCents ?? null,
		claimErrorMessage: h,
		sellErrorMessage: g,
		onClaim: () => void s.claim(),
		onSellBack: b,
		onAutoClaimChange: y,
		onOpenAgain: K,
		settledAction: E,
		claimedItems: c.claimStatus === "claimed" ? c.claim?.items : void 0,
		itemActions: x,
		onWithdrawItem: S,
		buttonClassName: Q.primaryButton,
		secondaryButtonClassName: Q.secondaryButton,
		demo: p
	}), oe = () => T ? /* @__PURE__ */ V(B, { children: T({
		state: c,
		openAgain: K
	}) }) : ae(!0), se = L(0), ce = L(F);
	return ce.current === "post" && F === "pre" && (se.current += 1), ce.current = F, /* @__PURE__ */ H("div", {
		className: q("los-root", Q.root, A),
		style: j,
		"data-los-host-idle": C && i.stage !== "all" && F === "pre" && t && !o ? "" : void 0,
		children: [i.stage === "all" ? /* @__PURE__ */ V("div", {
			className: Q.phase,
			"data-los-phase": F,
			children: (() => {
				if (o || !t) return /* @__PURE__ */ V("div", {
					className: Q.loading,
					children: M.loading
				});
				let e = F === "pre" ? ne() : F === "during" ? re() : T ? T({
					state: c,
					openAgain: K
				}) : ae(!1);
				return /* @__PURE__ */ V("div", {
					className: q(Q.revealStage, Q.stageOwned),
					children: G(t, {
						run: se.current,
						phase: F,
						controls: e
					})
				});
			})()
		}) : /* @__PURE__ */ H("div", {
			className: Q.phase,
			"data-los-phase": F,
			children: [
				F === "pre" && W(),
				F === "during" && ie(),
				F === "post" && oe()
			]
		}, F), k ? /* @__PURE__ */ V("div", {
			className: Q.fairnessArea,
			children: k
		}) : null]
	});
}
//#endregion
//#region src/LootBoxOpener.tsx
var Gr = 5;
function Kr(e) {
	let t = ae(), n = e.publishableKey ?? t.publishableKey, r = e.baseUrl ?? t.baseUrl, a = e.sessionToken ?? t.sessionToken ?? null, s = e.sessionPending ?? t.sessionPending ?? !1, c = e.onSessionExpired ?? t.onSessionExpired, l = e.client ?? t.client, u = e.createClient ?? t.createClient, f = e.theme ?? t.theme, p = e.sounds ?? t.sounds, m = e.soundBaseUrl ?? t.soundBaseUrl, h = e.locale ?? t.locale, g = e.currency ?? t.currency ?? i, v = I(() => C(h), [h]), y = le({
		sounds: p,
		soundBaseUrl: m
	}), { client: b, error: x } = Ar({
		client: l,
		createClient: u,
		publishableKey: n,
		baseUrl: r,
		sessionToken: a,
		onSessionExpired: c
	}), { box: S, loading: w, error: T } = Tr({
		client: b,
		boxId: e.boxId
	}), E = e.opener, D = I(() => S && E ? {
		...S,
		opener: E
	} : S, [S, E]), O = D?.opener?.kind, k = D?.opener?.theme, A = I(() => wr(O), [O]);
	N(() => A.preload?.(), [A]);
	let M = I(() => o(d(f, k)), [f, k]), [P, F] = tr({
		clientSeed: e.clientSeed,
		onClientSeedChange: e.onClientSeedChange
	}), z = !s && !a && !l, B = A.supportsBulk ? Math.max(1, Math.min(Gr, e.maxQuantity ?? Gr)) : 1, H = L({
		client: b,
		box: D,
		clientSeed: P,
		isDemoMode: z
	});
	H.current = {
		client: b,
		box: D,
		clientSeed: P,
		isDemoMode: z
	};
	let { mutateAsync: ee } = G({
		mutationKey: [
			"loot-os",
			"open",
			Jn(b)
		],
		mutationFn: (e) => {
			let t = H.current;
			if (!t.box) throw Error("[loot-os] box not loaded yet");
			if (!t.client) throw Error("[loot-os] no API client configured");
			return t.client.openBox({
				boxId: t.box.id,
				clientSeed: t.clientSeed,
				amount: e.quantity,
				expectedVersion: t.box.version,
				idempotencyKey: e.idempotencyKey
			});
		}
	}, Gn()), U = j(async (e) => {
		let t = H.current;
		if (!t.box) throw Error("[loot-os] box not loaded yet");
		return t.isDemoMode ? or(t.box, e, t.clientSeed) : ee({
			quantity: e,
			idempotencyKey: Yn()
		});
	}, [ee]), te = L(null), { mutateAsync: ne } = G({
		mutationKey: [
			"loot-os",
			"claim",
			Jn(b)
		],
		mutationFn: async (e) => {
			let t = H.current;
			if (!t.client) throw Error("[loot-os] no API client configured");
			let { claim: n } = await t.client.claimReveal({
				openGroupId: e.openGroupId,
				expectedPurchaseAmount: e.costCents
			});
			return n;
		}
	}, Gn()), W = j(async (e) => H.current.isDemoMode ? sr(e, te.current?.getState().entries ?? []) : ne(e), [ne]), { mutateAsync: re } = G({
		mutationKey: [
			"loot-os",
			"sell-back",
			Jn(b)
		],
		mutationFn: async (e) => {
			let t = H.current;
			if (!t.client?.sellBackReveal) throw Error("[loot-os] the API client cannot sell back");
			let { sale: n } = await t.client.sellBackReveal({
				openGroupId: e.openGroupId,
				expectedPurchaseAmount: e.costCents
			});
			return n;
		}
	}, Gn()), K = j(async (e) => H.current.isDemoMode ? cr(e, te.current?.getState().entries ?? []) : re(e), [re]), oe = z || typeof b?.sellBackReveal == "function", [se, ce] = R({}), q = L(e);
	q.current = e;
	let { machine: J, state: Y } = Or({
		openBox: U,
		claimReveal: W,
		sellBackReveal: K,
		onBeforeOpen: j((e) => q.current.onOpenStart?.(e), []),
		onEvent: j((e) => {
			let t = q.current;
			switch (e.type) {
				case "open_start":
				case "restored":
				case "reset":
					ce({});
					break;
				case "opened":
					t.onOpened?.(e.response);
					break;
				case "reveal_complete":
					t.onRevealComplete?.(e.response);
					break;
				case "claimed":
					t.onClaimed?.(e.claim);
					break;
				case "sold_back":
					t.onSoldBack?.(e.sale);
					break;
				case "claim_error":
				case "sell_back_error":
				case "error": Un(e.error) && e.error.code === "insufficient_balance" && t.onInsufficientBalance?.(e.error), t.onError?.(e.error);
			}
		}, []),
		maxQuantity: B,
		defaultQuantity: e.defaultQuantity,
		defaultQuickReveal: e.quickReveal === !0
	});
	te.current = J;
	let [ue, de] = R(0);
	N(() => {
		s && de((e) => e + 1);
	}, [s]);
	let fe = ie({
		queryKey: [
			"loot-os",
			"unclaimedReveal",
			Jn(b),
			ue
		],
		queryFn: async () => await b?.getUnclaimedReveal?.() ?? null,
		enabled: !s && !z && !!b?.getUnclaimedReveal,
		staleTime: 0,
		gcTime: 0
	}, Gn()), pe = L(!1);
	N(() => {
		let e = fe.data;
		pe.current || !e || (pe.current = !0, J.restore(e));
	}, [fe.data, J]);
	let me = s || fe.isLoading;
	N(() => {
		typeof e.quickReveal == "boolean" && J.setQuickReveal(e.quickReveal);
	}, [J, e.quickReveal]);
	let he = I(() => Vn({
		revealExit: A.revealExit,
		isQuickReveal: Y.isQuickReveal,
		actions: {
			finishReveal: () => J.completeReveal(),
			skipReveal: () => J.skip()
		}
	}), [
		J,
		Y.isQuickReveal,
		A
	]);
	N(() => {
		Y.phase !== "revealing" && he.cancel();
	}, [Y.phase, he]), N(() => () => he.cancel(), [he]);
	let ge = j(() => {
		y.unlock(), J.open();
	}, [J, y]), _e = j(() => void J.sellBack(), [J]), ve = j((e) => {
		ce((t) => ({
			...t,
			[e.inventoryItemId]: { status: "withdrawn" }
		})), q.current.onWithdrawRequested?.(e);
	}, []), ye = Y.error ?? T ?? x, be = ye ? Un(ye) ? ye.code === "insufficient_balance" ? v.errorInsufficientBalance : ye.code === "account_locked" ? v.errorAccountLocked : ye.message || v.errorGeneric : v.errorGeneric : null, xe = Y.claimError ? Un(Y.claimError) && Y.claimError.code === "insufficient_balance" ? v.errorInsufficientBalance : Un(Y.claimError) && Y.claimError.code === "account_locked" ? v.errorAccountLocked : v.errorClaimFailed : null, Se = Y.sellError ? Un(Y.sellError) && Y.sellError.code === "insufficient_balance" ? v.errorInsufficientBalance : Un(Y.sellError) && Y.sellError.code === "account_locked" ? v.errorAccountLocked : v.errorSellBackFailed : null, Ce = !z && typeof e.onWithdrawRequested == "function", we = !z && typeof b?.updateMySettings == "function", { mutate: Te } = G({
		mutationKey: [
			"loot-os",
			"settings",
			Jn(b)
		],
		mutationFn: async (e) => await H.current.client?.updateMySettings?.(e) ?? null
	}, Gn()), Ee = j((e) => {
		Te({ autoClaim: e });
	}, [Te]), De = I(() => ({
		strings: v,
		theme: M,
		sounds: y,
		currency: g,
		renderItemLabel: e.renderItemLabel
	}), [
		v,
		M,
		y,
		g,
		e.renderItemLabel
	]), Oe = e.showFairness ?? !0 ? /* @__PURE__ */ V(rr, {
		client: b,
		lastResponse: Y.lastResponse,
		clientSeed: P,
		onClientSeedChange: F,
		locked: Y.phase === "revealing" || Y.phase === "requesting"
	}) : null, ke = e.renderResults, Ae = ke ? ({ state: e, openAgain: t }) => ke({
		entries: e.entries,
		openAgain: t
	}) : void 0;
	return /* @__PURE__ */ V(_.Provider, {
		value: De,
		children: /* @__PURE__ */ V(Wr, {
			boxData: D,
			descriptor: A,
			loading: w || me,
			machine: J,
			state: Y,
			exit: he,
			maxQuantity: B,
			quickRevealMode: e.quickReveal ?? !1,
			isDemoMode: z,
			errorMessage: be,
			claimErrorMessage: xe,
			sellErrorMessage: Se,
			onOpenClick: ge,
			onSellBack: oe ? _e : void 0,
			itemActions: se,
			onWithdrawItem: Ce ? ve : void 0,
			onAutoClaimChange: we ? Ee : void 0,
			renderIdle: e.renderIdle,
			renderResults: Ae,
			settledAction: e.settledAction,
			prepaid: e.prepaid,
			fairnessPanel: Oe,
			className: e.className,
			style: {
				...M.cssVars,
				...e.style
			}
		})
	});
}
//#endregion
//#region src/react/LootProvider.tsx
function qr({ children: e, ...t }) {
	let n = I(() => t, [
		t.publishableKey,
		t.baseUrl,
		t.sessionToken,
		t.sessionPending,
		t.onSessionExpired,
		t.client,
		t.createClient,
		t.theme,
		t.sounds,
		t.soundBaseUrl,
		t.locale,
		t.currency
	]);
	return /* @__PURE__ */ V(K.Provider, {
		value: n,
		children: e
	});
}
//#endregion
export { sn as BATTLE_OPENER_COMPACT_BREAKPOINT_PX, Dn as BATTLE_PLAYER_COUNTS, An as BATTLE_REEL_TIMINGS, kn as BATTLE_SETTLE_MS, On as BATTLE_SPIN_START_DELAY_MS, En as BATTLE_START_COUNTDOWN_MS, Pn as BattleOpener, Fn as BattleResultsGrid, Rn as BattleStartingOverlay, Xn as CLIENT_SEED_STORAGE_KEY, i as DEFAULT_CURRENCY, Cr as DEFAULT_OPENER_KIND, s as DEFAULT_RARITY_RAIL_HEX, h as DEFAULT_RARITY_RGB, b as DEFAULT_STRINGS, Kr as LootBoxOpener, qr as LootProvider, Zn as MAX_CLIENT_SEED_LENGTH, vt as MOTION_ANIMATION_DURATION, Ct as MOTION_ENDING_ITEM_IDX, yt as MOTION_QUICK_ANIMATION_DURATION, xt as MOTION_QUICK_STAGGER_DELAY, wt as MOTION_REVEAL_LINGER_MS, _t as MOTION_SECOND_PHASE_ANIMATION_DURATION, bt as MOTION_STAGGER_DELAY, St as MOTION_STARTING_ITEM_IDX, Sr as OPENER_DESCRIPTORS, rr as ProvablyFairPanel, g as RESULT_RANGE, zn as REVEAL_START_DELAY_MS, oe as SoundPlayer, Cn as battleOpenerLayout, v as battleReelGenerator, jn as battleRevealIntervalMs, Mn as battleRoundRevealMs, Nn as battleSpinItems, Bn as createOpenerMachine, Vn as createOpenerRevealExit, S as currencyFractionDigits, t as currencyUnitName, T as defineOpenerDescriptor, e as formatAmount, x as formatAmountWithUnit, Et as generateItemWheel, Tt as generateRandomItems, u as getItemChance, r as getItemRarity, w as getOpenerPhase, f as getRarityGlowFilter, l as getRarityGlowFilterByRarity, c as getSpinnerRailColor, p as hashSeed, Hn as isDemoOpenResponse, Un as isLootApiErrorLike, d as mergeLootTheme, Sn as normalizeBattlePlayerCount, D as registerOpener, y as resolveKindTokens, wr as resolveOpenerDescriptor, ce as resolveSoundManifest, C as resolveStrings, o as resolveTheme, m as selectFromDropTable, tr as useClientSeed, Tr as useLootBox, ae as useLootProviderConfig, Er as useOpenBox, Or as useOpenerMachine, Dr as useOpenerMachineState, le as useOpenerSounds };

//# sourceMappingURL=index.js.map